<template>
  <div :class="isRTL ? 'ltr' : ''">
    <script v-html="jsonld" type="application/ld+json"></script>
    <div class="wrapper wrapper_mob">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        ref="LangModal"
        id="LangModal"
        hide-header
        hide-footer
        class="country-modal"
      >
        <div class="modal-title">Choose movie language</div>

        <div class="p-3">
          <div class="row">
            <div
              class="mb-2 text-white col"
              v-for="(Lang, Langindex) in ShowLang"
              :key="Langindex"
              v-on:click="setLanguage(Lang, Langindex)"
            >
              <!-- <img :src="country.Flag" height="60px" width="100px" /> -->
              <b-button style="width: 130px" class="btn-white cursor-pointer">{{
                Lang.Title
              }}</b-button>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
        no-close-on-esc
        hide-header-close
        ref="LateNightPopup"
        id="LateNightPopup"
        hide-header
        hide-footer
        class="country-modal"
      >
        <div class="p-3 text-center">
          <h5>This is late night show (Early Hours of Next Day)</h5>
          <button class="btn btn-pink" @click="closeLateNightPopup()">
            OK
          </button>
        </div>
      </b-modal>

      <!-- <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        ref="tncModal"
        id="tncModal"
        hide-header
        hide-footer
        class="country-modal"
      >
        <div v-if="ratingContent && ratingContent.title" class="modal-title">
          <h4>{{ ratingContent.title }}</h4>
        </div>
        <div v-if="ratingContent" class="d-flex mx-2">
          <div v-if="ratingContent.image && false" class="col-3">
            <img :src="ratingContent.image" alt="rating_icon" />
          </div>
          <div class="col-12">
            <p v-if="ratingContent && ratingContent.content">
              <span v-html="ratingContent.content"></span>
            </p>
          </div> -->
      <!-- <ol class="list-group text-white px-4">
              <li>Ticket is Compulsory for Children of 3 years & Above.</li>
              <li>Age restrictions apply as per the certification and suitability of the film.</li>
              <li>At the Cinema’s discretion and in accordance with UAE regulations, Cinema’s reserves the right to request proof of ID and users can be asked to leave by the cinema if they are under the permissible age of a movie.</li>
              <li>Returns and exchanges on purchased tickets through the Ticketak platform are not permitted.</li>
              <li>Decisions taken by Cinema’s Management team is final & abiding.</li>
              <li>Outside food & Beverages is not permitted inside cinema premises.</li>
            </ol>-->
      <!-- </div>

        <div v-if="ratingContent" class="row mx-0 py-3">
          <div class="col-6">
            <button
              type="button"
              v-on:click="onCancel()"
              class="btn-confirm active"
            >
              {{ $t("Cancel") }}
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              v-on:click="onClickCinemaTime()"
              class="btn-confirm active"
            >
              {{ $t("Accept") }}
            </button>
          </div>
        </div>
      </b-modal> -->
      <div class="go-back">
        <a
          @click="$router.go(-1)"
          style="cursor: pointer;"
          class="font-weight-bold"
          >Go back
        </a>
      </div>
      <section class="movieDetailsBanner">
        <div class="d-flex cinema_details" v-if="movieDetails.title">
          <div class="poster_img">
            <img v-lazy="movieDetails.movie_card_img" class="img-fluid" alt />
            <!-- <a :href="trailer.url" data-fancybox class="btn-play"></a> -->
          </div>
          <div class="movie_content w-75 mx-2 px-md-3 mt-1 mt-md-3">
            <!-- FIRST ROW -->
            <div class="lh-1 mb-md-2 mb-lg-2">
              <div
                class="d-flex flex-wrap align-items-center mb-md-3"
                :class="isRTL ? 'rtl' : ''"
              >
                <div class="movieTitle">{{ $t(movieDetails.title) }}</div>

                <div class="d-md-block">
                  <div class="d-flex align-items-center mx-2">
                    <!-- <div
                      class="favourite"
                      v-on:click="addtoFav()"
                      :class="movieDetails.favourite ? 'check' : ''"
                    ></div> -->
                    <!-- <input
                      v-on:click="addtoFav()"
                      :class="movieDetails.favourite ? 'check' : ''"
                      active-color="#FF0000"
                      type="checkbox"
                      class="favourite"
                      id="fav"
                    />-->
                    <!-- <label class="mb-0" for="fav">
                      {{ $t("INTERESTED") }}
                      <span v-if="!movieDetails.favourite">?</span>
                    </label> -->
                  </div>
                </div>
              </div>

              <div
                :class="[
                  'mb-2 lh-1-5 d-flex flex-wrap',
                  isRTL ? 'rtl alignment-mob' : 'ltr'
                ]"
              >
                <span>{{ movieDetails.rated }}</span>
                <span class="mx-1">|</span>
                <span>{{ movieDetails.genre }}</span>
                <span class="mx-1">|</span>
                <span>{{ movieDetails.lang }}</span>
                <span class="mx-1">|</span>
                <span class="format_my">{{ movieDetails.format }}</span>
              </div>
              <!-- <div class="w-100 d-none ellipses-two d-lg-block">{{movieDetails.plot}}</div> -->
              <div
                style="min-height: 65px"
                v-if="
                  movieDetails.hasOwnProperty('plot') &&
                    movieDetails.plot &&
                    movieDetails.plot.length > 0
                "
                :class="['d-none d-xl-flex d-md-block', isRTL ? 'rtl' : 'ltr']"
              >
                <read-more
                  more-str="read more"
                  :text="movieDetails.plot"
                  link="#"
                  less-str="read less"
                  :max-chars="200"
                  class="read-more"
                ></read-more>
              </div>
              <div
                v-if="
                  movieDetails.hasOwnProperty('plot') &&
                    movieDetails.plot &&
                    movieDetails.plot.length > 0
                "
                class="d-md-none d-block"
              >
                <read-more
                  more-str="read more"
                  :text="movieDetails.plot"
                  link="#"
                  less-str="read less"
                  :max-chars="60"
                  class="read-more"
                ></read-more>
              </div>
            </div>

            <!-- SECOND ROW -->
            <div
              class="movie-info-grid mb-md-3 mb-lg-4 mt-3"
              :class="isRTL ? 'rtl' : ''"
            >
              <div class="movieInfo">
                <div class="small">{{ $t("RELEASE_DATE") }}</div>
                <div>
                  <img
                    src="@/assets/img/icons/calendar.svg"
                    height="16px"
                    width="16px"
                    alt
                  />
                  {{ movieDetails.release }}
                </div>
              </div>

              <div class="movieInfo">
                <div class="small">{{ $t("RUNTIME") }}</div>
                <img
                  src="@/assets/img/icons/clock_new.svg"
                  height="16px"
                  width="16px"
                  alt
                />
                <!--img src="@/assets/img/icons/clock.png" height="16px" width="16px" alt /-->
                {{ movieDetails.runtime }}
              </div>
              <div class="movieInfo">
                <div class="small">IMDB Rating</div>
                <h6>{{ movieDetails.IMDBRating }}</h6>
                <!-- <star-rating
                    v-on:click.native="
                      validateBeforeSubmit('addOnlyUserRating')
                    "
                    :show-rating="false"
                    :rating="
                      parseInt(
                        rating.currentUserRatingDetails.currentUserRating
                      )
                    "
                    :inline="true"
                    :increment="0.5"
                    active-color="#ffc107"
                    :star-size="20"
                    v-model="rating.currentUserRatingDetails.currentUserRating"
                  ></star-rating> -->
              </div>

              <!-- <div class="movieInfo d-none d-md-block">
                <div class="small">{{ $t("INTERESTED") }}</div>
                <img
                  src="@/assets/img/icons/heart-filled.svg"
                  height="16px"
                  width="16px"
                  alt
                />
                <span v-if="movieDetails.interestedcount > 0">{{
                  movieDetails.interestedcount
                }}</span>
              </div> -->
            </div>

            <!-- FOURTH ROW -->
            <div class="d-none d-md-block">
              <div class="d-flex mb-md-3 mb-lg-4" :class="isRTL ? 'rtl' : ''">
                <!-- <div class="movieInfo">
                  <div class="small">{{$t("CRITICSRATING")}}</div>
                  <star-rating
                    :show-rating="movieDetails.criticsrating == 0 || movieDetails.criticsrating == '0'? false : true"
                    :rating="parseFloat(movieDetails.criticsrating)"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    :active-color="ActiveColor"
                    :star-size="20"
                  ></star-rating>
                </div>
                <div class="movieInfo">
                  <div class="small">{{$t("USER_RATING")}}</div>
                  <star-rating
                    :show-rating="movieDetails.useravaragerating == 0 || movieDetails.useravaragerating == '0' ? false :true"
                    :rating="parseFloat(movieDetails.useravaragerating)"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    :active-color="ActiveColor"
                    :star-size="20"
                  ></star-rating>
                </div> -->
              </div>
            </div>

            <!-- <div>
              <hr class="mt-1 mb-1" style="background-color: white" />
            </div> -->

            <!-- MOBILE ROW -->
            <!-- <div class="d-md-none">
              <div class="movieInfo">
                <div class="small">Your Rating 101</div>
                <star-rating
                  v-on:click.native="validateBeforeSubmit('addOnlyUserRating')"
                  :show-rating="false"
                  :inline="true"
                  :increment="0.5"
                  active-color="#ffc107"
                  :star-size="20"
                  v-model="rating.currentUserRatingDetails.currentUserRating"
                ></star-rating>
              </div>
            </div> -->

            <div class="mb-md-2 mb-lg-4 d-block d-md-none">
              <div :class="['small d-flex', isRTL ? 'rtl' : 'ltr']">
                {{ $t("MOVIE_TRIALER") }}
              </div>
              <div
                class="d-flex position-relative"
                
                :class="isRTL ? 'rtl' : ''"
              >
                <div
                  v-for="(trailer, youtubeKey) in youtubes"
                  :key="youtubeKey"
                 
                  class="mobile-trailer-box"
                >
                  <a :href="trailer.url" data-fancybox class="btn-play"></a>
                </div>

              
              </div>
             
            </div>
            <!-- FIFTH ROW -->
            <div class="mb-md-2 mb-lg-4 d-none d-md-block">
              <div :class="['small d-flex', isRTL ? 'rtl' : 'ltr']">
                {{ $t("MOVIE_TRIALER") }}
              </div>
              <div
                class="d-flex position-relative"
                style="min-height: 118px"
                :class="isRTL ? 'rtl' : ''"
              >
                <div
                  v-for="(trailer, youtubeKey) in youtubes"
                  :key="youtubeKey"
                  v-bind:style="{
                    'background-image': 'url(' + trailer.thumbnail + ')'
                  }"
                  class="trailer-box"
                >
                  <a :href="trailer.url" data-fancybox class="btn-play"></a>
                </div>

                <!-- <div class="position-absolute" :style=" isRTL ? 'bottom:0;left:0;' : 'bottom:0;right:0;'">
                  <img
                    class="cursor-pointer"
                    v-on:click="onclickShare()"
                    src="@/assets/img/svg/facebook.svg"
                    height="40"
                    width="40"
                    alt
                  />

                  <img
                    v-on:click="onClickTwitterShare()"
                    class="cursor-pointer"
                    src="@/assets/img/svg/twitter.svg"
                    height="40"
                    width="40"
                    alt
                  />
                </div> -->
              </div>
              <!-- <div class="text-right">
                <button class="btn btn-pink">Book</button>
              </div> -->
              <!-- <a :href="trailer.url" data-fancybox class="btn-play">
                <div
                  class="trailer-box"
                  v-bind:style="{ 'background-image': 'url(' + trailer.thumbnail + ')' }"
                >
                  <a :href="trailer.url" data-fancybox class="btn-play"></a>
                </div>
              </a>-->
            </div>
          </div>
        </div>

        <!-- <div>
          <hr class="my-3 d-block d-md-none" />
        </div>

        <div class="d-block d-md-none">
          <div class="row ml-0 mr-0 mb-3">
            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">Interested</div>
                  <img
                    src="@/assets/img/icons/heart-filled.svg"
                    height="auto"
                    width="16px"
                    alt
                  />
                  {{ movieDetails.interestedcount }}
                </div>
              </div>
            </div>

            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">Critics Rating</div>
                  <star-rating
                    :show-rating="
                      movieDetails.criticsrating == 0 ||
                      movieDetails.criticsrating == '0'
                        ? false
                        : true
                    "
                    :rating="parseInt(movieDetails.criticsrating)"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-sm-4 col-4">
              <div class="responsive-show">
                <div class="movieInfo d-md-none d-block">
                  <div class="small">User Rating</div>
                  <star-rating
                    :show-rating="
                      movieDetails.useravaragerating == 0 ||
                      movieDetails.useravaragerating == '0'
                        ? false
                        : true
                    "
                    :rating="parseInt(movieDetails.useravaragerating)"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </section>

      <div class="section-space"></div>

      <section class="showtimes-section">
        <h4>{{ $t("Showdays") }}</h4>
        <div class="custom-shadow mt-3" v-if="filters.length > 0">
          <div
            v-for="(filter, filterKey) in filters"
            v-if="filter.filter_key === 'show_date'"
            :key="index"
            class="mob_date_section showtime-date-section"
          >
            <div
              v-for="(filterList, filterListKey) in filter.all_filter"
              :key="filterListKey"
              v-if="filterList.inputtype == 'radio'"
              class=""
            >
              <div
                class="showtime-date-btn "
                :style="{
                  color: selectedDate == filterList.title ? '#fff' : '',
                  background:
                    selectedDate == filterList.title ? 'var(--pink)' : ''
                }"
                v-on:click="
                  onClickFilter(
                    filter.filter_key,
                    filterList.value,
                    filterListKey,
                    filterList.title
                  )
                "
              >
                <!-- {{ filterList }} -->
                <span>{{ moment(filterList.title1).format("D") }}</span>
                <span class="day">{{
                  moment(filterList.title1).format("MMM")
                }}</span>
                <span class="day">{{
                  moment(filterList.title1).format("ddd")
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-3 mx-0 " :class="isRTL ? 'rtl' : ''">
          <div
            class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"
            v-if="false"
          >
            <div
              class="accordian-container"
              v-for="(filter, filterKey) in filters"
              :key="filterKey"
            >
              <button
                class="btn-accordian no-focus"
                :class="
                  selectedFilter &&
                  selectedFilter[filter.filter_key] &&
                  selectedFilter[filter.filter_key].length > 0
                    ? 'active'
                    : ''
                "
                @click="onToggle(filter.collapseId)"
              >
                <img :src="filter.icon" height="15px" width="15px" />
                <span v-if="filter.filter_key == 'show_date'">{{
                  selectedDate
                }}</span>
                <span v-else>{{ filter.filter_name }}</span>
              </button>
              <b-collapse
                class="accordian-container"
                accordion="my-accordion"
                role="tabpanel"
                :id="filter.collapseId"
              >
                <!--<div
                      class="btn-accordian-child d-flex align-items-center"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <div v-if="filterList.inputtype == 'radio'">
                        <span
                          :class="filterList.value == selectedFilter['show_date'][0] ? 'active':''"
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                        >{{filterList.title}}</span>
                      </div>
                      <div v-else class="d-flex align-items-center">
                        <input
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                          :id="filter.filter_key+filterListKey"
                          name="showdate"
                          type="checkbox"
                          :value="filterList.value"
                          :checked="((selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][0]) || (selectedFilter['movie_language'] && filterList.value === selectedFilter['movie_language'][0])) ? true : false"
                        />
                        <label
                          class="mb-0"
                          :for="filter.filter_key+filterListKey"
                          :checked="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterKey]) ? true : false"
                        >{{filterList.title}}</label>
                      </div>
                    </div>-->

                <!-- Copy New  -->
                <div
                  class="btn-accordian-child d-flex align-items-center"
                  v-for="(filterList, filterListKey) in filter.all_filter"
                  :key="filterListKey"
                  v-if="filterList.inputtype == 'radio'"
                  v-on:click="
                    onClickFilter(
                      filter.filter_key,
                      filterList.value,
                      filterListKey,
                      filterList.title
                    )
                  "
                >
                  <label>
                    <span
                      :class="
                        selectedFilter['show_date'] &&
                        filterList.value == selectedFilter['show_date'][0]
                          ? 'active'
                          : ''
                      "
                      >{{ filterList.title }}</span
                    >
                  </label>
                </div>
                <label
                  class="btn-accordian-child d-flex align-items-center"
                  v-for="(filterList, filterListKey) in filter.all_filter"
                  :key="filterListKey"
                  v-if="filterList.inputtype !== 'radio'"
                >
                  <div class="d-flex align-items-center">
                    <input
                      v-on:click="
                        onClickFilter(
                          filter.filter_key,
                          filterList.value,
                          filterListKey,
                          filterList.title
                        )
                      "
                      :id="filter.filter_key + filterListKey"
                      name="showdate"
                      type="checkbox"
                      :value="filterList.value"
                      :checked="
                        (selectedFilter[filter.filter_key] &&
                          filterList.value ==
                            selectedFilter[filter.filter_key][0]) ||
                        (selectedFilter['movie_language'] &&
                          filterList.value ===
                            selectedFilter['movie_language'][0])
                          ? true
                          : false
                      "
                    />
                    <label
                      class="mb-0"
                      :for="filter.filter_key + filterListKey"
                      :checked="
                        selectedFilter[filter.filter_key] &&
                        filterList.value ==
                          selectedFilter[filter.filter_key][filterKey]
                          ? true
                          : false
                      "
                      >{{ filterList.title }}</label
                    >
                  </div>
                </label>
                <!-- Copy New End -->

                <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                    </ul>-->
              </b-collapse>
            </div>
            <Advertise />
          </div>
          <div
            v-if="shows.length > 0"
            class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none"
          >
            <!-- TODAY FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.cinemas class="btn-accordian">
                <img
                  src="@/assets/img/svg/icon-calendar.svg"
                  height="18px"
                  width="18px"
                />
                {{ selectedDate.Date }}
              </button>
              <b-collapse class="btn-accordian-content" id="cinemas">
                <button
                  v-b-toggle.cinemas
                  v-for="(singleDate, singleDateKey) in allDates"
                  :key="singleDateKey"
                  class="btn-accordian-child"
                  v-on:click="filterShowData(singleDate, 'date')"
                >
                  {{ singleDate.ShowDate }}
                </button>
                <!-- <ul class="filter-list px-2">
                      <li v-for="(singleDate ,singleDateKey) in allDates" :key="singleDateKey">

                          <input type="radio" name="rdbschClass"  v-model="selectedDate" :value="singleDate.Date"> {{singleDate.Date}}<br>

                      </li>
                    </ul>-->
              </b-collapse>
            </div>

            <!-- LOCATION FILTER -->
            <!-- <div class="accordian-container">
                  <button v-b-toggle.locationFilter class="btn-accordian">Location</button>
                  <b-collapse class="btn-accordian-content" id="locationFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

            <!-- CINEMAS FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.cinemasFilter class="btn-accordian text-over">
                <img
                  src="@/assets/img/svg/icon-video.svg"
                  height="18px"
                  width="18px"
                />
                {{ selectedCinema }}
              </button>
              <b-collapse class="btn-accordian-content" id="cinemasFilter">
                <button
                  v-b-toggle.cinemasFilter
                  v-for="(cinema, cinemaKey) in allcinemas"
                  :key="cinemaKey"
                  class="btn-accordian-child text-over"
                  v-on:click="filterShowData(cinema.name, 'cinema')"
                >
                  {{ cinema.name }}
                </button>

                <!-- <ul class="filter-list px-2">
                      <li v-for="(cinema ,cinemaKey) in allcinemas" :key="cinemaKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(cinema.name, 'cinema')" v-model="selectedCinema" :value="cinema.name"> {{cinema.name}}<br>

                      </li>
                    </ul>-->
              </b-collapse>
            </div>

            <!-- LANGUAGE FILTER -->
            <!-- <div class="accordian-container">
                  <button v-b-toggle.cinemasFilter class="btn-accordian">
                    <img src="@/assets/img/svg/icon-world.svg" height="18px" width="18px">
                    Language
                  </button>
                  <b-collapse class="btn-accordian-content" id="cinemasFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

            <!-- FORMAT FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.typeFilter class="btn-accordian">
                <img
                  src="@/assets/img/icon-format.png"
                  height="20px"
                  width="20px"
                  alt
                />
                {{ selectedFormat }}
              </button>
              <b-collapse class="btn-accordian-content" id="typeFilter">
                <button
                  v-b-toggle.typeFilter
                  v-for="(format, formatKey) in format"
                  :key="formatKey"
                  class="btn-accordian-child"
                  v-on:click="filterShowData(format, 'format')"
                >
                  {{ format }}
                </button>

                <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
              </b-collapse>
            </div>
            <!-- LANGUAGE FILTER -->
            <div v-if="language.length > 0" class="accordian-container">
              <button v-b-toggle.languageFilter class="btn-accordian">
                <img
                  src="@/assets/img/icon-format.png"
                  height="20px"
                  width="20px"
                  alt
                />
                {{ selectedLanguage }}
              </button>
              <b-collapse class="btn-accordian-content" id="typeFilter">
                <button
                  v-b-toggle.languageFilter
                  v-for="(format, languageKey) in language"
                  :key="languageKey"
                  class="btn-accordian-child"
                  v-on:click="filterShowData(language, 'language')"
                >
                  {{ language }}
                </button>

                <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
              </b-collapse>
              <!-- </div> -->
            </div>
          </div>

          <div class="col-xl-12 px-0">
            <div class="col-12 px-0">
              <!-- Mobile Dates filtersChips -->
              <div class="d-md-none d-flex" :class="isRTL ? 'mb-2' : ''">
                <div
                  v-if="selectedDate != 'Show Date' && false"
                  style="font-size: 14px"
                  class="badge badge-pill bg-pink text-white"
                >
                  {{ selectedDate }}
                </div>
              </div>

              <div>
                <ul class="list-inline d-none">
                  <li
                    v-for="(filter, filterKey) in filtersChips"
                    :key="filterKey"
                    class="list-inline-item"
                  >
                    <div class="badge badge-pill bg-pink text-white">
                      {{ filter.title }}
                      <button
                        v-on:click="
                          onRemoveFilterChips(
                            filter.filter_key,
                            filter.value,
                            filterKey
                          )
                        "
                        class="btn-badge-close"
                      >
                        x
                      </button>
                    </div>
                  </li>
                  <!-- <li v-if="filtersChips.length >0" class="list-inline-item">
                        <div class="badge badge-pill bg-pink text-white">
                          Clear All
                          <button
                            v-on:click="onClearAllFilters()"
                            class="btn-badge-close"
                          >x</button>
                        </div>
                      </li>-->
                </ul>
              </div>
              <!--START NEW DESIGN -- Ruchitha -->
              <div
                    class="row pt-3 mx-0 "
                    v-if="tabIndex == 0"
                    :class="isRTL ? 'rtl' : ''"
                  >
                    <div class="custom-shadow col-lg-12">
                      <div
                        class="d-flex align-items-center"
                        v-if="isShowsLoaded == false"
                      >
                        <strong>Please wait...</strong>
                        <b-spinner variant="success" class="ml-2"></b-spinner>
                      </div>

                      <div v-if="shows.length == 0 && isShowsLoaded == true">
                        No Shows Available
                      </div>
                      <div
                        v-for="(show, showtimeListKey) in shows"
                        :key="showtimeListKey"
                      >
                        <h6
                          class="font-weight-bold"
                          :class="['', isRTL ? 'rtl' : 'ltr']"
                        >
                          {{ show.name }}
                        </h6>
                        <div
                          :class="[isRTL ? 'pr-0' : '']"
                          class="showtime-list-grid"
                          v-for="(timingList,
                          timingListKey) in show.screenWiseTimeings"
                          :key="timingListKey"
                        >
                          <div>
                            <p>
                              {{ timingList[0].screen_name }}
                            </p>
                          </div>
                          <ul class="showtime-list-items">
                            <li
                              v-for="(timingListNew,
                              timingListKey1) in timingList"
                              :key="timingListKey1"
                              :id="'tooltip' + timingListKey1 + showtimeListKey"
                              class="movie-moon-hover"
                            >
                              <!-- <router-link
                  v-if="timingListNew.format == '2D'"
                  to
                  v-on:click.native="
                    onAccept(timingListNew, timingList)
                  "
                >
                  <p style="width: 100%; margin: 0">
                    {{ timingListNew.time }}
                    <br />
                    <span style="font-size: 12px">{{
                      timingListNew.Screentype
                    }}</span>
                  </p>
                </router-link> -->
                              <!-- v-on:click.native="
                    onAccept(timingListNew, timingList)
                  " -->
                              <div
                                v-b-tooltip.hover
                                :title="
                                  AvailableSeats
                                    ? 'Available Seats:' + AvailableSeats
                                    : ''
                                "
                                @click="
                                  checkLateNightPopup(
                                    timingListNew.Latenightpopup,
                                    timingListNew,
                                    timingList
                                  )
                                "
                              >
                                <div class="list-li">
                                  <div class="d-flex align-items-center">
                                    <p>
                                      {{ timingListNew.time }}
                                    </p>
                                    <figure v-if="timingListNew.Latenightpopup">
                                      <img src="@/assets/img/half-moon.svg" />
                                    </figure>
                                  </div>
                                  <div>
                                    <p>
                                      <span v-if="timingListNew.format"
                                        >( {{ timingListNew.format }} )</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              <b-tabs
                v-model="tabIndex"
                class="movieDetails-tabs pt-3 d-none"
                :class="isRTL ? 'rtl' : ''"
              >
                <!-- SHOWTIMES TAB -->
                <b-tab
                  :disabled="
                    shows.length == 0 && categoryId == 3 ? true : false
                  "
                  title="All"
                  @click="setShows('0')"
                  class="show-time-tab"
                >
                  <div
                    class="row pt-3 mx-0 "
                    v-if="tabIndex == 0"
                    :class="isRTL ? 'rtl' : ''"
                  >
                    <div class="custom-shadow col-lg-12">
                      <div
                        class="d-flex align-items-center"
                        v-if="isShowsLoaded == false"
                      >
                        <strong>Please wait...</strong>
                        <b-spinner variant="success" class="ml-2"></b-spinner>
                      </div>

                      <div v-if="shows.length == 0 && isShowsLoaded == true">
                        No Shows Available
                      </div>
                      <div
                        v-for="(show, showtimeListKey) in shows"
                        :key="showtimeListKey"
                      >
                        <h6
                          class="font-weight-bold"
                          v-on:click="filterShowData(show.name, 'cinema')"
                          :class="['', isRTL ? 'rtl' : 'ltr']"
                        >
                          {{ show.name }}
                        </h6>
                        <div
                          :class="[isRTL ? 'pr-0' : '']"
                          class="showtime-list-grid"
                          v-for="(timingList,
                          timingListKey) in show.screenWiseTimeings"
                          :key="timingListKey"
                        >
                          <div>
                            <p>
                              {{ timingList[0].screen_name }}
                            </p>
                          </div>
                          <ul class="showtime-list-items">
                            <li
                              v-for="(timingListNew,
                              timingListKey1) in timingList"
                              :key="timingListKey1"
                              :id="'tooltip' + timingListKey1 + showtimeListKey"
                              class="movie-moon-hover"
                            >
                              <!-- <router-link
                  v-if="timingListNew.format == '2D'"
                  to
                  v-on:click.native="
                    onAccept(timingListNew, timingList)
                  "
                >
                  <p style="width: 100%; margin: 0">
                    {{ timingListNew.time }}
                    <br />
                    <span style="font-size: 12px">{{
                      timingListNew.Screentype
                    }}</span>
                  </p>
                </router-link> -->
                              <!-- v-on:click.native="
                    onAccept(timingListNew, timingList)
                  " -->
                              <div
                                v-b-tooltip.hover
                                :title="
                                  AvailableSeats
                                    ? 'Available Seats:' + AvailableSeats
                                    : ''
                                "
                                @click="
                                  checkLateNightPopup(
                                    timingListNew.Latenightpopup,
                                    timingListNew,
                                    timingList
                                  )
                                "
                              >
                                <div class="list-li">
                                  <div class="d-flex align-items-center">
                                    <p>
                                      {{ timingListNew.time }}
                                    </p>
                                    <figure v-if="timingListNew.Latenightpopup">
                                      <img src="@/assets/img/half-moon.svg" />
                                    </figure>
                                  </div>
                                  <div>
                                    <p>
                                      <span v-if="timingListNew.format"
                                        >( {{ timingListNew.format }} )</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <!-- MOVIE DETAILS TAB -->
                <b-tab
                  :disabled="
                    shows.length == 0 && categoryId == 3 ? true : false
                  "
                  title="Cineco"
                  @click="setShows('3')"
                  class="show-time-tab"
                >
                  <div
                    class="row pt-3 mx-0 "
                    v-if="tabIndex == 1"
                    :class="isRTL ? 'rtl' : ''"
                  >
                    <div
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"
                      v-if="false"
                    >
                      <div
                        class="accordian-container"
                        v-for="(filter, filterKey) in filters"
                        :key="filterKey"
                      >
                        <button
                          class="btn-accordian no-focus"
                          :class="
                            selectedFilter &&
                            selectedFilter[filter.filter_key] &&
                            selectedFilter[filter.filter_key].length > 0
                              ? 'active'
                              : ''
                          "
                          @click="onToggle(filter.collapseId)"
                        >
                          <img :src="filter.icon" height="15px" width="15px" />
                          <span v-if="filter.filter_key == 'show_date'">{{
                            selectedDate
                          }}</span>
                          <span v-else>{{ filter.filter_name }}</span>
                        </button>
                        <b-collapse
                          class="accordian-container"
                          accordion="my-accordion"
                          role="tabpanel"
                          :id="filter.collapseId"
                        >
                          <!--<div
                      class="btn-accordian-child d-flex align-items-center"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <div v-if="filterList.inputtype == 'radio'">
                        <span
                          :class="filterList.value == selectedFilter['show_date'][0] ? 'active':''"
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                        >{{filterList.title}}</span>
                      </div>
                      <div v-else class="d-flex align-items-center">
                        <input
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                          :id="filter.filter_key+filterListKey"
                          name="showdate"
                          type="checkbox"
                          :value="filterList.value"
                          :checked="((selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][0]) || (selectedFilter['movie_language'] && filterList.value === selectedFilter['movie_language'][0])) ? true : false"
                        />
                        <label
                          class="mb-0"
                          :for="filter.filter_key+filterListKey"
                          :checked="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterKey]) ? true : false"
                        >{{filterList.title}}</label>
                      </div>
                    </div>-->

                          <!-- Copy New  -->
                          <div
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype == 'radio'"
                            v-on:click="
                              onClickFilter(
                                filter.filter_key,
                                filterList.value,
                                filterListKey,
                                filterList.title
                              )
                            "
                          >
                            <label>
                              <span
                                :class="
                                  selectedFilter['show_date'] &&
                                  filterList.value ==
                                    selectedFilter['show_date'][0]
                                    ? 'active'
                                    : ''
                                "
                                >{{ filterList.title }}</span
                              >
                            </label>
                          </div>
                          <label
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype !== 'radio'"
                          >
                            <div class="d-flex align-items-center">
                              <input
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                                :id="filter.filter_key + filterListKey"
                                name="showdate"
                                type="checkbox"
                                :value="filterList.value"
                                :checked="
                                  (selectedFilter[filter.filter_key] &&
                                    filterList.value ==
                                      selectedFilter[filter.filter_key][0]) ||
                                  (selectedFilter['movie_language'] &&
                                    filterList.value ===
                                      selectedFilter['movie_language'][0])
                                    ? true
                                    : false
                                "
                              />
                              <label
                                class="mb-0"
                                :for="filter.filter_key + filterListKey"
                                :checked="
                                  selectedFilter[filter.filter_key] &&
                                  filterList.value ==
                                    selectedFilter[filter.filter_key][filterKey]
                                    ? true
                                    : false
                                "
                                >{{ filterList.title }}</label
                              >
                            </div>
                          </label>
                          <!-- Copy New End -->

                          <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                    </ul>-->
                        </b-collapse>
                      </div>
                      <Advertise />
                    </div>
                    <div
                      v-if="shows.length > 0"
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none"
                    >
                      <!-- TODAY FILTER -->
                      <div class="accordian-container">
                        <button v-b-toggle.cinemas class="btn-accordian">
                          <img
                            src="@/assets/img/svg/icon-calendar.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedDate.Date }}
                        </button>
                        <b-collapse class="btn-accordian-content" id="cinemas">
                          <button
                            v-b-toggle.cinemas
                            v-for="(singleDate, singleDateKey) in allDates"
                            :key="singleDateKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(singleDate, 'date')"
                          >
                            {{ singleDate.ShowDate }}
                          </button>
                          <!-- <ul class="filter-list px-2">
                      <li v-for="(singleDate ,singleDateKey) in allDates" :key="singleDateKey">

                          <input type="radio" name="rdbschClass"  v-model="selectedDate" :value="singleDate.Date"> {{singleDate.Date}}<br>

                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>

                      <!-- LOCATION FILTER -->
                      <!-- <div class="accordian-container">
                  <button v-b-toggle.locationFilter class="btn-accordian">Location</button>
                  <b-collapse class="btn-accordian-content" id="locationFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

                      <!-- CINEMAS FILTER -->
                      <div class="accordian-container">
                        <button
                          v-b-toggle.cinemasFilter
                          class="btn-accordian text-over"
                        >
                          <img
                            src="@/assets/img/svg/icon-video.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedCinema }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="cinemasFilter"
                        >
                          <button
                            v-b-toggle.cinemasFilter
                            v-for="(cinema, cinemaKey) in allcinemas"
                            :key="cinemaKey"
                            class="btn-accordian-child text-over"
                            v-on:click="filterShowData(cinema.name, 'cinema')"
                          >
                            {{ cinema.name }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(cinema ,cinemaKey) in allcinemas" :key="cinemaKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(cinema.name, 'cinema')" v-model="selectedCinema" :value="cinema.name"> {{cinema.name}}<br>

                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>

                      <!-- LANGUAGE FILTER -->
                      <!-- <div class="accordian-container">
                  <button v-b-toggle.cinemasFilter class="btn-accordian">
                    <img src="@/assets/img/svg/icon-world.svg" height="18px" width="18px">
                    Language
                  </button>
                  <b-collapse class="btn-accordian-content" id="cinemasFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

                      <!-- FORMAT FILTER -->
                      <div class="accordian-container">
                        <button v-b-toggle.typeFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedFormat }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.typeFilter
                            v-for="(format, formatKey) in format"
                            :key="formatKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(format, 'format')"
                          >
                            {{ format }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>
                      <!-- LANGUAGE FILTER -->
                      <div
                        v-if="language.length > 0"
                        class="accordian-container"
                      >
                        <button v-b-toggle.languageFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedLanguage }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.languageFilter
                            v-for="(format, languageKey) in language"
                            :key="languageKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(language, 'language')"
                          >
                            {{ language }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
                        </b-collapse>
                        <!-- </div> -->
                      </div>
                    </div>

                    <div class="col-xl-12 px-0">
                      <div class="col-12 px-0">
                        <!-- Mobile Dates filtersChips -->
                        <div
                          class="d-md-none d-flex"
                          :class="isRTL ? 'mb-2' : ''"
                        >
                          <div
                            v-if="selectedDate != 'Show Date' && false"
                            style="font-size: 14px"
                            class="badge badge-pill bg-pink text-white"
                          >
                            {{ selectedDate }}
                          </div>
                        </div>

                        <div>
                          <ul class="list-inline d-none">
                            <li
                              v-for="(filter, filterKey) in filtersChips"
                              :key="filterKey"
                              class="list-inline-item"
                            >
                              <div class="badge badge-pill bg-pink text-white">
                                {{ filter.title }}
                                <button
                                  v-on:click="
                                    onRemoveFilterChips(
                                      filter.filter_key,
                                      filter.value,
                                      filterKey
                                    )
                                  "
                                  class="btn-badge-close"
                                >
                                  x
                                </button>
                              </div>
                            </li>
                            <!-- <li v-if="filtersChips.length >0" class="list-inline-item">
                        <div class="badge badge-pill bg-pink text-white">
                          Clear All
                          <button
                            v-on:click="onClearAllFilters()"
                            class="btn-badge-close"
                          >x</button>
                        </div>
                      </li>-->
                          </ul>
                        </div>
                        <!--START NEW DESIGN -- Ruchitha -->
                        <div class="custom-shadow">
                          <div
                            class="d-flex align-items-center"
                            v-if="isShowsLoaded == false"
                          >
                            <strong>Please wait...</strong>
                            <b-spinner
                              variant="success"
                              class="ml-2"
                            ></b-spinner>
                          </div>
                          <div
                            v-if="shows.length == 0 && isShowsLoaded == true"
                          >
                            No Shows Available
                          </div>
                          <div
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                            <h6
                              class="font-weight-bold"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="['', isRTL ? 'rtl' : 'ltr']"
                            >
                              {{ show.name }}
                            </h6>
                            <div
                              :class="[isRTL ? 'pr-0' : '']"
                              class="showtime-list-grid"
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div>
                                <p>
                                  {{ timingList[0].screen_name }}
                                </p>
                              </div>
                              <ul class="showtime-list-items">
                                <li
                                  v-for="(timingListNew,
                                  timingListKey1) in timingList"
                                  :key="timingListKey1"
                                  :id="
                                    'tooltip' + timingListKey1 + showtimeListKey
                                  "
                                  class="movie-moon-hover"
                                >
                                  <!-- <router-link
                              v-if="timingListNew.format == '2D'"
                              to
                              v-on:click.native="
                                onAccept(timingListNew, timingList)
                              "
                            >
                              <p style="width: 100%; margin: 0">
                                {{ timingListNew.time }}
                                <br />
                                <span style="font-size: 12px">{{
                                  timingListNew.Screentype
                                }}</span>
                              </p>
                            </router-link> -->
                                  <!-- v-on:click.native="
                                onAccept(timingListNew, timingList)
                              " -->
                                  <div
                                    @click="
                                      checkLateNightPopup(
                                        timingListNew.Latenightpopup,
                                        timingListNew,
                                        timingList
                                      )
                                    "
                                  >
                                    <div class="list-li">
                                      <div class="d-flex align-items-center">
                                        <p>
                                          {{ timingListNew.time }}
                                        </p>
                                        <figure
                                          v-if="timingListNew.Latenightpopup"
                                        >
                                          <img
                                            src="@/assets/img/half-moon.svg"
                                          />
                                        </figure>
                                      </div>
                                      <div>
                                        <p>
                                          <span v-if="timingListNew.format"
                                            >(
                                            {{ timingListNew.format }} )</span
                                          >
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <!--END NEW DESIGN-->
                        <ul
                          :class="[
                            'showtime-list mobile_scrollable',
                            isRTL ? 'pr-0' : 'pl-lg-3'
                          ]"
                          class="d-none"
                        >
                          <div
                            v-for="(filter, filterKey) in filters"
                            v-if="filter.filter_key === 'show_date'"
                            class="d-flex flex-md-wrap mob_date_section"
                            style="gap: 10px"
                          >
                            <div
                              v-for="(filterList,
                              filterListKey) in filter.all_filter"
                              :key="filterListKey"
                              v-if="filterList.inputtype == 'radio'"
                              class="date_section"
                            >
                              <button
                                class="date_btn"
                                :style="{
                                  'background-color':
                                    selectedDate == filterList.title
                                      ? 'var(--pink)'
                                      : 'gray'
                                }"
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                              >
                                {{ filterList.title }}
                              </button>
                            </div>
                          </div>

                          <li
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                            <!-- <router-link :to="{ name: 'cinemaDetails', params: { cinemaId: show['id'] }}"> -->
                            <h5
                              style="cursor: pointer"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="[
                                'cinema-name mb-1 d-flex',
                                isRTL ? 'rtl' : 'ltr'
                              ]"
                            >
                              {{ show.name }}
                            </h5>

                            <!-- - {{show.location}} -->
                            <!-- </router-link> -->
                            <ol
                              :class="[isRTL ? 'pr-0' : '']"
                              class=""
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div class="m-3">
                                <p>
                                  <small>{{ timingList[0].screen_name }}</small>
                                </p>
                              </div>
                              <li
                                v-for="(timingListNew,
                                timingListKey1) in timingList"
                                :key="timingListKey1"
                                :id="
                                  'tooltip' + timingListKey1 + showtimeListKey
                                "
                              >
                                <router-link
                                  to
                                  v-on:click.native="
                                    onAccept(timingListNew, timingList)
                                  "
                                >
                                  <p style="width: 100%; margin: 0">
                                    {{ timingListNew.time }}
                                    <br />
                                    <span
                                      v-if="timingListNew.format"
                                      style="font-size: 12px"
                                      >({{ timingListNew.format }})</span
                                    >
                                  </p>
                                </router-link>
                              </li>
                            </ol>
                          </li>
                          <li v-if="shows.length == 0">
                            {{ $t("NO_SHOWS_FOUND") }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="pl-5 pt-1" v-if="shows.length == 0 && false">
                      {{ $t("NO_SHOWS_FOUND") }}
                    </div>
                  </div>
                </b-tab>

                <b-tab
                  :disabled="
                    shows.length == 0 && categoryId == 3 ? true : false
                  "
                  title="Mukta"
                  @click="setShows('7')"
                  class="show-time-tab"
                >
                  <div
                    class="row pt-3 mx-0 "
                    v-if="tabIndex == 2"
                    :class="isRTL ? 'rtl' : ''"
                  >
                    <div
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"
                      v-if="false"
                    >
                      <div
                        class="accordian-container"
                        v-for="(filter, filterKey) in filters"
                        :key="filterKey"
                      >
                        <button
                          class="btn-accordian no-focus"
                          :class="
                            selectedFilter &&
                            selectedFilter[filter.filter_key] &&
                            selectedFilter[filter.filter_key].length > 0
                              ? 'active'
                              : ''
                          "
                          @click="onToggle(filter.collapseId)"
                        >
                          <img :src="filter.icon" height="15px" width="15px" />
                          <span v-if="filter.filter_key == 'show_date'">{{
                            selectedDate
                          }}</span>
                          <span v-else>{{ filter.filter_name }}</span>
                        </button>
                        <b-collapse
                          class="accordian-container"
                          accordion="my-accordion"
                          role="tabpanel"
                          :id="filter.collapseId"
                        >
                          <!--<div
                      class="btn-accordian-child d-flex align-items-center"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <div v-if="filterList.inputtype == 'radio'">
                        <span
                          :class="filterList.value == selectedFilter['show_date'][0] ? 'active':''"
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                        >{{filterList.title}}</span>
                      </div>
                      <div v-else class="d-flex align-items-center">
                        <input
                          v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                          :id="filter.filter_key+filterListKey"
                          name="showdate"
                          type="checkbox"
                          :value="filterList.value"
                          :checked="((selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][0]) || (selectedFilter['movie_language'] && filterList.value === selectedFilter['movie_language'][0])) ? true : false"
                        />
                        <label
                          class="mb-0"
                          :for="filter.filter_key+filterListKey"
                          :checked="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterKey]) ? true : false"
                        >{{filterList.title}}</label>
                      </div>
                    </div>-->

                          <!-- Copy New  -->
                          <div
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype == 'radio'"
                            v-on:click="
                              onClickFilter(
                                filter.filter_key,
                                filterList.value,
                                filterListKey,
                                filterList.title
                              )
                            "
                          >
                            <label>
                              <span
                                :class="
                                  selectedFilter['show_date'] &&
                                  filterList.value ==
                                    selectedFilter['show_date'][0]
                                    ? 'active'
                                    : ''
                                "
                                >{{ filterList.title }}</span
                              >
                            </label>
                          </div>
                          <label
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype !== 'radio'"
                          >
                            <div class="d-flex align-items-center">
                              <input
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                                :id="filter.filter_key + filterListKey"
                                name="showdate"
                                type="checkbox"
                                :value="filterList.value"
                                :checked="
                                  (selectedFilter[filter.filter_key] &&
                                    filterList.value ==
                                      selectedFilter[filter.filter_key][0]) ||
                                  (selectedFilter['movie_language'] &&
                                    filterList.value ===
                                      selectedFilter['movie_language'][0])
                                    ? true
                                    : false
                                "
                              />
                              <label
                                class="mb-0"
                                :for="filter.filter_key + filterListKey"
                                :checked="
                                  selectedFilter[filter.filter_key] &&
                                  filterList.value ==
                                    selectedFilter[filter.filter_key][filterKey]
                                    ? true
                                    : false
                                "
                                >{{ filterList.title }}</label
                              >
                            </div>
                          </label>
                          <!-- Copy New End -->

                          <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                    </ul>-->
                        </b-collapse>
                      </div>
                      <Advertise />
                    </div>
                    <div
                      v-if="shows.length > 0"
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none"
                    >
                      <!-- TODAY FILTER -->
                      <div class="accordian-container">
                        <button v-b-toggle.cinemas class="btn-accordian">
                          <img
                            src="@/assets/img/svg/icon-calendar.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedDate.Date }}
                        </button>
                        <b-collapse class="btn-accordian-content" id="cinemas">
                          <button
                            v-b-toggle.cinemas
                            v-for="(singleDate, singleDateKey) in allDates"
                            :key="singleDateKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(singleDate, 'date')"
                          >
                            {{ singleDate.ShowDate }}
                          </button>
                          <!-- <ul class="filter-list px-2">
                      <li v-for="(singleDate ,singleDateKey) in allDates" :key="singleDateKey">

                          <input type="radio" name="rdbschClass"  v-model="selectedDate" :value="singleDate.Date"> {{singleDate.Date}}<br>

                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>

                      <!-- LOCATION FILTER -->
                      <!-- <div class="accordian-container">
                  <button v-b-toggle.locationFilter class="btn-accordian">Location</button>
                  <b-collapse class="btn-accordian-content" id="locationFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

                      <!-- CINEMAS FILTER -->
                      <div class="accordian-container">
                        <button
                          v-b-toggle.cinemasFilter
                          class="btn-accordian text-over"
                        >
                          <img
                            src="@/assets/img/svg/icon-video.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedCinema }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="cinemasFilter"
                        >
                          <button
                            v-b-toggle.cinemasFilter
                            v-for="(cinema, cinemaKey) in allcinemas"
                            :key="cinemaKey"
                            class="btn-accordian-child text-over"
                            v-on:click="filterShowData(cinema.name, 'cinema')"
                          >
                            {{ cinema.name }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(cinema ,cinemaKey) in allcinemas" :key="cinemaKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(cinema.name, 'cinema')" v-model="selectedCinema" :value="cinema.name"> {{cinema.name}}<br>

                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>

                      <!-- LANGUAGE FILTER -->
                      <!-- <div class="accordian-container">
                  <button v-b-toggle.cinemasFilter class="btn-accordian">
                    <img src="@/assets/img/svg/icon-world.svg" height="18px" width="18px">
                    Language
                  </button>
                  <b-collapse class="btn-accordian-content" id="cinemasFilter">
                    <ul class="filter-list px-2">
                      <li v-for="(filterList ,filterListKey) in 5" :key="filterListKey">
                        <label for="date">Movie Date</label>
                        <input id="date" type="checkbox">
                      </li>
                    </ul>
                  </b-collapse>
                </div>-->

                      <!-- FORMAT FILTER -->
                      <div class="accordian-container">
                        <button v-b-toggle.typeFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedFormat }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.typeFilter
                            v-for="(format, formatKey) in format"
                            :key="formatKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(format, 'format')"
                          >
                            {{ format }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
                        </b-collapse>
                      </div>
                      <!-- LANGUAGE FILTER -->
                      <div
                        v-if="language.length > 0"
                        class="accordian-container"
                      >
                        <button v-b-toggle.languageFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedLanguage }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.languageFilter
                            v-for="(format, languageKey) in language"
                            :key="languageKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(language, 'language')"
                          >
                            {{ language }}
                          </button>

                          <!-- <ul class="filter-list px-2">
                      <li v-for="(format ,formatKey) in movieDetails.format" :key="formatKey">
                          <input type="radio" name="rdbschClass" v-on:click="filterShowData(format, 'format')" v-model="selectedFormat" :value="format"> {{format}}<br>
                      </li>
                    </ul>-->
                        </b-collapse>
                        <!-- </div> -->
                      </div>
                    </div>

                    <div class="col-xl-12 px-0">
                      <div class="col-12 px-0">
                        <!-- Mobile Dates filtersChips -->
                        <div
                          class="d-md-none d-flex"
                          :class="isRTL ? 'mb-2' : ''"
                        >
                          <div
                            v-if="selectedDate != 'Show Date' && false"
                            style="font-size: 14px"
                            class="badge badge-pill bg-pink text-white"
                          >
                            {{ selectedDate }}
                          </div>
                        </div>

                        <div>
                          <ul class="list-inline d-none">
                            <li
                              v-for="(filter, filterKey) in filtersChips"
                              :key="filterKey"
                              class="list-inline-item"
                            >
                              <div class="badge badge-pill bg-pink text-white">
                                {{ filter.title }}
                                <button
                                  v-on:click="
                                    onRemoveFilterChips(
                                      filter.filter_key,
                                      filter.value,
                                      filterKey
                                    )
                                  "
                                  class="btn-badge-close"
                                >
                                  x
                                </button>
                              </div>
                            </li>
                            <!-- <li v-if="filtersChips.length >0" class="list-inline-item">
                        <div class="badge badge-pill bg-pink text-white">
                          Clear All
                          <button
                            v-on:click="onClearAllFilters()"
                            class="btn-badge-close"
                          >x</button>
                        </div>
                      </li>-->
                          </ul>
                        </div>
                        <!--START NEW DESIGN -- Ruchitha -->
                        <div class="custom-shadow">
                          <div
                            class="d-flex align-items-center"
                            v-if="isShowsLoaded == false"
                          >
                            <strong>Please wait...</strong>
                            <b-spinner
                              variant="success"
                              class="ml-2"
                            ></b-spinner>
                          </div>
                          <div
                            v-if="shows.length == 0 && isShowsLoaded == true"
                          >
                            No Shows Available
                          </div>
                          <div
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                            <h6
                              class="font-weight-bold"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="['', isRTL ? 'rtl' : 'ltr']"
                            >
                              {{ show.name }}
                            </h6>
                            <div
                              :class="[isRTL ? 'pr-0' : '']"
                              class="showtime-list-grid"
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div class="">
                                <p>
                                  {{ timingList[0].screen_name }}
                                </p>
                              </div>
                              <ul class="showtime-list-items">
                                <li
                                  v-for="(timingListNew,
                                  timingListKey1) in timingList"
                                  :key="timingListKey1"
                                  :id="
                                    'tooltip' + timingListKey1 + showtimeListKey
                                  "
                                  class="movie-moon-hover"
                                >
                                  <!-- <router-link
                              v-if="timingListNew.format == '2D'"
                              to
                              v-on:click.native="
                                onAccept(timingListNew, timingList)
                              "
                            >
                              <p style="width: 100%; margin: 0">
                                {{ timingListNew.time }}
                                <br />
                                <span style="font-size: 12px">{{
                                  timingListNew.Screentype
                                }}</span>
                              </p>
                            </router-link> -->
                                  <!-- v-on:click.native="
                                onAccept(timingListNew, timingList)
                              " -->
                                  <div
                                    @click="
                                      checkLateNightPopup(
                                        timingListNew.Latenightpopup,
                                        timingListNew,
                                        timingList
                                      )
                                    "
                                  >
                                    <div class="list-li">
                                      <div class="d-flex align-items-center">
                                        <p>
                                          {{ timingListNew.time }}
                                        </p>
                                        <figure
                                          v-if="timingListNew.Latenightpopup"
                                        >
                                          <img
                                            src="@/assets/img/half-moon.svg"
                                          />
                                        </figure>
                                      </div>
                                      <div>
                                        <p>
                                          <span v-if="timingListNew.format"
                                            >(
                                            {{ timingListNew.format }} )</span
                                          >
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <!--END NEW DESIGN-->
                        <ul
                          :class="[
                            'showtime-list mobile_scrollable',
                            isRTL ? 'pr-0' : 'pl-lg-3'
                          ]"
                          class="d-none"
                        >
                          <div
                            v-for="(filter, filterKey) in filters"
                            v-if="filter.filter_key === 'show_date'"
                            class="d-flex flex-md-wrap mob_date_section"
                            style="gap: 10px"
                          >
                            <div
                              v-for="(filterList,
                              filterListKey) in filter.all_filter"
                              :key="filterListKey"
                              v-if="filterList.inputtype == 'radio'"
                              class="date_section"
                            >
                              <button
                                class="date_btn"
                                :style="{
                                  'background-color':
                                    selectedDate == filterList.title
                                      ? 'var(--pink)'
                                      : 'gray'
                                }"
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                              >
                                {{ filterList.title }}
                              </button>
                            </div>
                          </div>

                          <li
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                            <!-- <router-link :to="{ name: 'cinemaDetails', params: { cinemaId: show['id'] }}"> -->
                            <h5
                              style="cursor: pointer"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="[
                                'cinema-name mb-1 d-flex',
                                isRTL ? 'rtl' : 'ltr'
                              ]"
                            >
                              {{ show.name }}
                            </h5>

                            <!-- - {{show.location}} -->
                            <!-- </router-link> -->
                            <ol
                              :class="[isRTL ? 'pr-0' : '']"
                              class=""
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div class="m-3">
                                <p>
                                  <small>{{ timingList[0].screen_name }}</small>
                                </p>
                              </div>
                              <li
                                v-for="(timingListNew,
                                timingListKey1) in timingList"
                                :key="timingListKey1"
                                :id="
                                  'tooltip' + timingListKey1 + showtimeListKey
                                "
                              >
                                <router-link
                                  to
                                  v-on:click.native="
                                    onAccept(timingListNew, timingList)
                                  "
                                >
                                  <p style="width: 100%; margin: 0">
                                    {{ timingListNew.time }}
                                    <br />
                                    <span
                                      v-if="timingListNew.format"
                                      style="font-size: 12px"
                                      >({{ timingListNew.format }})</span
                                    >
                                  </p>
                                </router-link>
                              </li>
                            </ol>
                          </li>
                          <li v-if="shows.length == 0">
                            {{ $t("NO_SHOWS_FOUND") }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="pl-5 pt-1" v-if="shows.length == 0 && false">
                      {{ $t("NO_SHOWS_FOUND") }}
                    </div>
                  </div>
                </b-tab>

                <!-- <b-tab
                  :disabled="
                    shows.length == 0 && categoryId == 3 ? true : false
                  "
                  title="Novo"
                  @click="setShows('8')"
                  class="show-time-tab"
                >
                  <div
                    class="row pt-3 mx-0 "
                    v-if="tabIndex == 3"
                    :class="isRTL ? 'rtl' : ''"
                  >
                    <div
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none d-md-block"
                      v-if="false"
                    >
                      <div
                        class="accordian-container"
                        v-for="(filter, filterKey) in filters"
                        :key="filterKey"
                      >
                        <button
                          class="btn-accordian no-focus"
                          :class="
                            selectedFilter &&
                            selectedFilter[filter.filter_key] &&
                            selectedFilter[filter.filter_key].length > 0
                              ? 'active'
                              : ''
                          "
                          @click="onToggle(filter.collapseId)"
                        >
                          <img :src="filter.icon" height="15px" width="15px" />
                          <span v-if="filter.filter_key == 'show_date'">{{
                            selectedDate
                          }}</span>
                          <span v-else>{{ filter.filter_name }}</span>
                        </button>
                        <b-collapse
                          class="accordian-container"
                          accordion="my-accordion"
                          role="tabpanel"
                          :id="filter.collapseId"
                        >
                    

                        
                          <div
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype == 'radio'"
                            v-on:click="
                              onClickFilter(
                                filter.filter_key,
                                filterList.value,
                                filterListKey,
                                filterList.title
                              )
                            "
                          >
                            <label>
                              <span
                                :class="
                                  selectedFilter['show_date'] &&
                                  filterList.value ==
                                    selectedFilter['show_date'][0]
                                    ? 'active'
                                    : ''
                                "
                                >{{ filterList.title }}</span
                              >
                            </label>
                          </div>
                          <label
                            class="btn-accordian-child d-flex align-items-center"
                            v-for="(filterList,
                            filterListKey) in filter.all_filter"
                            :key="filterListKey"
                            v-if="filterList.inputtype !== 'radio'"
                          >
                            <div class="d-flex align-items-center">
                              <input
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                                :id="filter.filter_key + filterListKey"
                                name="showdate"
                                type="checkbox"
                                :value="filterList.value"
                                :checked="
                                  (selectedFilter[filter.filter_key] &&
                                    filterList.value ==
                                      selectedFilter[filter.filter_key][0]) ||
                                  (selectedFilter['movie_language'] &&
                                    filterList.value ===
                                      selectedFilter['movie_language'][0])
                                    ? true
                                    : false
                                "
                              />
                              <label
                                class="mb-0"
                                :for="filter.filter_key + filterListKey"
                                :checked="
                                  selectedFilter[filter.filter_key] &&
                                  filterList.value ==
                                    selectedFilter[filter.filter_key][filterKey]
                                    ? true
                                    : false
                                "
                                >{{ filterList.title }}</label
                              >
                            </div>
                          </label>
                         
                        </b-collapse>
                      </div>
                      <Advertise />
                    </div>
                    <div
                      v-if="shows.length > 0"
                      class="col-md-4 col-lg-3 col-xl-2 mb-3 d-none"
                    >
                    
                      <div class="accordian-container">
                        <button v-b-toggle.cinemas class="btn-accordian">
                          <img
                            src="@/assets/img/svg/icon-calendar.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedDate.Date }}
                        </button>
                        <b-collapse class="btn-accordian-content" id="cinemas">
                          <button
                            v-b-toggle.cinemas
                            v-for="(singleDate, singleDateKey) in allDates"
                            :key="singleDateKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(singleDate, 'date')"
                          >
                            {{ singleDate.ShowDate }}
                          </button>
                        
                        </b-collapse>
                      </div>

                     
                    

                      <div class="accordian-container">
                        <button
                          v-b-toggle.cinemasFilter
                          class="btn-accordian text-over"
                        >
                          <img
                            src="@/assets/img/svg/icon-video.svg"
                            height="18px"
                            width="18px"
                          />
                          {{ selectedCinema }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="cinemasFilter"
                        >
                          <button
                            v-b-toggle.cinemasFilter
                            v-for="(cinema, cinemaKey) in allcinemas"
                            :key="cinemaKey"
                            class="btn-accordian-child text-over"
                            v-on:click="filterShowData(cinema.name, 'cinema')"
                          >
                            {{ cinema.name }}
                          </button>

                        </b-collapse>
                      </div>

                     

                      
                      <div class="accordian-container">
                        <button v-b-toggle.typeFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedFormat }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.typeFilter
                            v-for="(format, formatKey) in format"
                            :key="formatKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(format, 'format')"
                          >
                            {{ format }}
                          </button>

                        
                        </b-collapse>
                      </div>
                    
                      <div
                        v-if="language.length > 0"
                        class="accordian-container"
                      >
                        <button v-b-toggle.languageFilter class="btn-accordian">
                          <img
                            src="@/assets/img/icon-format.png"
                            height="20px"
                            width="20px"
                            alt
                          />
                          {{ selectedLanguage }}
                        </button>
                        <b-collapse
                          class="btn-accordian-content"
                          id="typeFilter"
                        >
                          <button
                            v-b-toggle.languageFilter
                            v-for="(format, languageKey) in language"
                            :key="languageKey"
                            class="btn-accordian-child"
                            v-on:click="filterShowData(language, 'language')"
                          >
                            {{ language }}
                          </button>

                        </b-collapse>
                     
                      </div>
                    </div>

                    <div class="col-xl-12 px-0">
                      <div class="col-12 px-0">
                       
                        <div
                          class="d-md-none d-flex"
                          :class="isRTL ? 'mb-2' : ''"
                        >
                          <div
                            v-if="selectedDate != 'Show Date' && false"
                            style="font-size: 14px"
                            class="badge badge-pill bg-pink text-white"
                          >
                            {{ selectedDate }}
                          </div>
                        </div>

                        <div>
                          <ul class="list-inline d-none">
                            <li
                              v-for="(filter, filterKey) in filtersChips"
                              :key="filterKey"
                              class="list-inline-item"
                            >
                              <div class="badge badge-pill bg-pink text-white">
                                {{ filter.title }}
                                <button
                                  v-on:click="
                                    onRemoveFilterChips(
                                      filter.filter_key,
                                      filter.value,
                                      filterKey
                                    )
                                  "
                                  class="btn-badge-close"
                                >
                                  x
                                </button>
                              </div>
                            </li>
                         
                          </ul>
                        </div>
                      
                        <div class="custom-shadow">
                          <div
                            class="d-flex align-items-center"
                            v-if="isShowsLoaded == false"
                          >
                            <strong>Please wait...</strong>
                            <b-spinner
                              variant="success"
                              class="ml-2"
                            ></b-spinner>
                          </div>
                          <div
                            v-if="shows.length == 0 && isShowsLoaded == true"
                          >
                            No Shows Available
                          </div>
                          <div
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                            <h6
                              class="font-weight-bold"
                              style="cursor: pointer"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="['', isRTL ? 'rtl' : 'ltr']"
                            >
                              {{ show.name }}
                            </h6>
                            <div
                              :class="[isRTL ? 'pr-0' : '']"
                              class="showtime-list-grid"
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div class="">
                                <p>
                                  {{ timingList[0].screen_name }}
                                </p>
                              </div>
                              <ul class="showtime-list-items">
                                <li
                                  v-for="(timingListNew,
                                  timingListKey1) in timingList"
                                  :key="timingListKey1"
                                  :id="
                                    'tooltip' + timingListKey1 + showtimeListKey
                                  "
                                  class="movie-moon-hover"
                                >
                               
                                  <div
                                    @click="
                                      checkLateNightPopup(
                                        timingListNew.Latenightpopup,
                                        timingListNew,
                                        timingList
                                      )
                                    "
                                  >
                                    <div class="list-li">
                                      <div class="d-flex align-items-center">
                                        <p>
                                          {{ timingListNew.time }}
                                        </p>
                                        <figure
                                          v-if="timingListNew.Latenightpopup"
                                        >
                                          <img
                                            src="@/assets/img/half-moon.svg"
                                          />
                                        </figure>
                                      </div>
                                      <div>
                                        <p>
                                          <span v-if="timingListNew.format"
                                            >(
                                            {{ timingListNew.format }} )</span
                                          >
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                      
                        <ul
                          :class="[
                            'showtime-list mobile_scrollable',
                            isRTL ? 'pr-0' : 'pl-lg-3'
                          ]"
                          class="d-none"
                        >
                          <div
                            v-for="(filter, filterKey) in filters"
                            v-if="filter.filter_key === 'show_date'"
                            class="d-flex flex-md-wrap mob_date_section"
                            style="gap: 10px"
                          >
                            <div
                              v-for="(filterList,
                              filterListKey) in filter.all_filter"
                              :key="filterListKey"
                              v-if="filterList.inputtype == 'radio'"
                              class="date_section"
                            >
                              <button
                                class="date_btn"
                                :style="{
                                  'background-color':
                                    selectedDate == filterList.title
                                      ? 'var(--pink)'
                                      : 'gray'
                                }"
                                v-on:click="
                                  onClickFilter(
                                    filter.filter_key,
                                    filterList.value,
                                    filterListKey,
                                    filterList.title
                                  )
                                "
                              >
                                {{ filterList.title }}
                              </button>
                            </div>
                          </div>

                          <li
                            v-for="(show, showtimeListKey) in shows"
                            :key="showtimeListKey"
                          >
                         
                            <h5
                              style="cursor: pointer"
                              v-on:click="filterShowData(show.name, 'cinema')"
                              :class="[
                                'cinema-name mb-1 d-flex',
                                isRTL ? 'rtl' : 'ltr'
                              ]"
                            >
                              {{ show.name }}
                            </h5>

                          
                            <ol
                              :class="[isRTL ? 'pr-0' : '']"
                              class=""
                              v-for="(timingList,
                              timingListKey) in show.screenWiseTimeings"
                              :key="timingListKey"
                            >
                              <div class="m-3">
                                <p>
                                  <small>{{ timingList[0].screen_name }}</small>
                                </p>
                              </div>
                              <li
                                v-for="(timingListNew,
                                timingListKey1) in timingList"
                                :key="timingListKey1"
                                :id="
                                  'tooltip' + timingListKey1 + showtimeListKey
                                "
                              >
                                <router-link
                                  to
                                  v-on:click.native="
                                    onAccept(timingListNew, timingList)
                                  "
                                >
                                  <p style="width: 100%; margin: 0">
                                    {{ timingListNew.time }}
                                    <br />
                                    <span
                                      v-if="timingListNew.format"
                                      style="font-size: 12px"
                                      >({{ timingListNew.format }})</span
                                    >
                                  </p>
                                </router-link>
                              </li>
                            </ol>
                          </li>
                          <li v-if="shows.length == 0">
                            {{ $t("NO_SHOWS_FOUND") }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="pl-5 pt-1" v-if="shows.length == 0 && false">
                      {{ $t("NO_SHOWS_FOUND") }}
                    </div>
                  </div>
                </b-tab> -->
              </b-tabs>
              <ul
                :class="[
                  'showtime-list mobile_scrollable',
                  isRTL ? 'pr-0' : 'pl-lg-3'
                ]"
                class="d-none"
              >
                <div
                  v-for="(filter, filterKey) in filters"
                  v-if="filter.filter_key === 'show_date'"
                  class="d-flex flex-md-wrap mob_date_section"
                  style="gap: 10px"
                >
                  <div
                    v-for="(filterList, filterListKey) in filter.all_filter"
                    :key="filterListKey"
                    v-if="filterList.inputtype == 'radio'"
                    class="date_section"
                  >
                    <button
                      class="date_btn"
                      :style="{
                        'background-color':
                          selectedDate == filterList.title
                            ? 'var(--pink)'
                            : 'gray'
                      }"
                      v-on:click="
                        onClickFilter(
                          filter.filter_key,
                          filterList.value,
                          filterListKey,
                          filterList.title
                        )
                      "
                    >
                      {{ filterList.title }}
                    </button>
                  </div>
                </div>

                <li
                  v-for="(show, showtimeListKey) in shows"
                  :key="showtimeListKey"
                >
                  <!-- <router-link :to="{ name: 'cinemaDetails', params: { cinemaId: show['id'] }}"> -->
                  <h5
                    style="cursor: pointer"
                    v-on:click="filterShowData(show.name, 'cinema')"
                    :class="['cinema-name mb-1 d-flex', isRTL ? 'rtl' : 'ltr']"
                  >
                    {{ show.name }}
                  </h5>

                  <!-- - {{show.location}} -->
                  <!-- </router-link> -->
                  <ol
                    :class="[isRTL ? 'pr-0' : '']"
                    class=""
                    v-for="(timingList,
                    timingListKey) in show.screenWiseTimeings"
                    :key="timingListKey"
                  >
                    <div class="m-3">
                      <p>
                        <small>{{ timingList[0].screen_name }}</small>
                      </p>
                    </div>
                    <li
                      v-for="(timingListNew, timingListKey1) in timingList"
                      :key="timingListKey1"
                      :id="'tooltip' + timingListKey1 + showtimeListKey"
                    >
                      <!-- <router-link
                            v-if="timingListNew.format == '2D'"
                            to
                            v-on:click.native="
                              onAccept(timingListNew, timingList)
                            "
                          >
                            <p style="width: 100%; margin: 0">
                              {{ timingListNew.time }}
                              <br />
                              <span style="font-size: 12px">{{
                                timingListNew.Screentype
                              }}</span>
                            </p>
                          </router-link> -->
                      <router-link
                        to
                        v-on:click.native="onAccept(timingListNew, timingList)"
                      >
                        <p style="width: 100%; margin: 0">
                          {{ timingListNew.time }}
                          <br />
                          <span
                            v-if="timingListNew.format"
                            style="font-size: 12px"
                            >({{ timingListNew.format }})</span
                          >
                        </p>
                      </router-link>
                    </li>
                  </ol>
                </li>
                <li v-if="shows.length == 0">
                  {{ $t("NO_SHOWS_FOUND") }}
                </li>
              </ul>
            </div>
          </div>
          <div class="pl-5 pt-1" v-if="shows.length == 0 && false">
            {{ $t("NO_SHOWS_FOUND") }}
          </div>
        </div>
      </section>

      <div class="section-space"></div>
      <section class="d-none">
        <h4>{{ $t("Events you might be interested in ") }}</h4>
        <div class="container-fluid pt-3">
          <div class="row" :class="isRTL ? 'rtl' : 'ltr'">
            <div
              class="col-6 col-lg-2 px-2"
              v-for="(data, index) in this.allShowingEvents"
              :key="index"
            >
              <div
                class="event-card"
                @click="goToEventDetails(data)"
                v-if="index < 6"
              >
                <img
                  :src="event_img_base_url + data.e_image"
                  class="w-100 event-image-ht"
                />
                <div class="event-card-details">
                  <div>
                    <h6 class="mb-0 text-truncate">{{ data.e_name }}</h6>
                    <div>
                      <span>
                        {{ moment(data.es_date).format("MMM. D, YYYY") }} -
                        {{ moment(data.ee_date).format("MMM. D, YYYY") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <p class="text-pink font-weight-bold text-right">
                        {{ data.currency }}
                        {{ data.price }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="container-fluid d-none">
      <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
        <div class="slider-container w-100 d-flex flex-wrap">
          <div class="col-6 col-xl-4 pl-0 pb-3 pb-md-0">
            <div class="col-lg-1 px-0">
              <!-- <img :src="movieDetails.AppImageMovies" class="cinema-poster" alt> -->
              <img src="@/assets/img/alita325.jpg" class="img" alt />
            </div>
          </div>
          <div
            class="
              col-6 col-xl-8
              h-100
              d-flex
              flex-column
              justify-content-between
              py-3
            "
          >
            <!-- TOP SECTION  -->
            <div>
              <!-- DESKTOP FIRST ROW -->
              <div class="d-flex align-items-center mb-1">
                <div class="slider-title mb-0">{{ movieDetails.title }}</div>
                <div class="d-none d-md-block">
                  <div class="d-flex align-items-center mt-1 ml-3">
                    <input type="checkbox" class="favourite" id="fav" />
                    <label class="mb-0" for="fav">Interested</label>
                  </div>
                  <div class="my-2 text-info">{{ ratingMessage }}</div>
                </div>
              </div>

              <!-- <p class="font-weight-bold">
                {{movieDetails.plot}}
              </p>-->

              <!-- DESKTOP SECOND ROW -->
              <div class="row mx-0 mb-3">
                <div class="fs-14 text-dark">
                  <span class="font-weight-bold">{{ movieDetails.rated }}</span>
                  <span>|</span>
                  <span>{{ movieDetails.genre }}</span>
                  <span>|</span>
                  <span>{{ movieDetails.lang }}</span>
                  <span>|</span>
                  <span class="format">{{ movieDetails.format }}</span>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-5 col-xl-3">
                  <div class="small">Release Date</div>
                  <div class="movie-release mr-2 d-flex align-items-center">
                    <img
                      src="@/assets/img/icon-calender.png"
                      class="mr-1"
                      height="15px"
                      width="15px"
                    />
                    {{ movieDetails.release }}
                  </div>
                </div>
                <div class="col-auto">
                  <div class="small">Runtime</div>
                  <div class="movie-duration d-flex align-items-center">
                    <img
                      src="@/assets/img/icon-clock.png"
                      class="mr-1"
                      height="15px"
                      width="15px"
                    />
                    {{ movieDetails.runtime }}
                  </div>
                </div>
                <div class="col-auto">
                  <div class="small">Favourite</div>
                  <div class="d-flex align-items-center">
                    <img
                      src="@/assets/img/svg/icon-heart-filled.svg"
                      class="mr-2"
                      height="15px"
                      width="15px"
                      alt="Heart-icon"
                    />
                    <span class="font-weight-bold">{{
                      movieDetails.interestedcount
                    }}</span>
                    <span class="small">&nbsp;(Times)</span>
                  </div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-3">
                  <div class="small">Critics Rating</div>
                  <star-rating
                    :show-rating="true"
                    :rating="parseInt(movieDetails.criticsrating)"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                  <span class="small">&nbsp;(13 Votes)</span>
                </div>
                <div class="col-auto">
                  <div class="small">Overall rating</div>
                  <star-rating
                    :show-rating="true"
                    :rating="2.5"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                  <span class="small">&nbsp;(13 Votes)</span>
                </div>

                <div class="col-auto">
                  <div class="small">User Rating</div>
                  <span class="font-weight-bold">4.3</span>
                  <star-rating
                    :show-rating="false"
                    :inline="true"
                    :increment="0.5"
                    active-color="#ffc107"
                    :star-size="20"
                    v-model="ratingDetails.currentUserRating"
                  ></star-rating>
                </div>
              </div>

              <!-- DESKTOP FOURTH ROW -->
              <!-- <div class="row mb-md-3 align-items-end">
                <div class="col-md-5 col-xl-2 mb-2 mb-md-0">
                  <div class="imdb-container">
                    <div class="box-1">IMDb</div>
                    <div class="box-2">{{movieDetails.IMDBRating}}</div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="small">User Rating</div>
                  <span class="font-weight-bold">4.3</span>
                  <star-rating :show-rating="false" :inline="true" :increment="0.5" active-color="#e5007d"
                    :star-size="20" v-model="ratingDetails.currentUserRating"></star-rating>
                </div>
              </div>-->

              <!-- DESKTOP FIFTH ROW -->
              <!-- <div class="d-none d-md-block">
                <hr>
                <div class="row mb-3">
                  <div class="col-xl-2">
                    <div class="small">Favourite</div>
                    <div class="d-flex align-items-center">
                      <img src="@/assets/img/svg/icon-heart-filled.svg" class="mr-2" height="15px" width="15px"
                        alt="Heart-icon">
                      <span class="font-weight-bold">{{movieDetails. interestedcount}}</span>
                      <span class="small">&nbsp;(Times)</span>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="small">Critics Rating</div>
                    <star-rating :show-rating="true" :rating="2.5" :increment="0.5" :inline="true" :read-only="true"
                      active-color="#e5007d" :star-size="13"></star-rating>
                    <span class="small">&nbsp;(13 Votes)</span>
                  </div>
                  <div class="col-auto">
                    <div class="small">Rating IT</div>
                    <star-rating :show-rating="true" :rating="2.5" :increment="0.5" :inline="true" :read-only="true"
                      active-color="#e5007d" :star-size="13"></star-rating>
                    <span class="small">&nbsp;(13 Votes)</span>
                  </div>
                </div>
              </div>-->
            </div>

            <!-- BOTTOM SECTION -->
            <div class="d-none d-md-block">
              <div class="d-flex justify-content-between align-items-end">
                <div>
                  <div class="small">Movie Trailer</div>
                  <div class="d-flex">
                    <div
                      v-for="(trailer, youtubeKey) in youtubes"
                      :key="youtubeKey"
                      v-bind:style="{
                        'background-image': 'url(' + trailer.thumbnail + ')'
                      }"
                      class="trailer-box"
                    >
                      <a :href="trailer.url" data-fancybox class="btn-play"></a>
                    </div>
                  </div>
                  <!-- <div class="d-flex d-none">
                    <div
                      class="trailer-box"
                      v-bind:style="{ 'background-image': 'url(' + trailer.thumbnail + ')' }"
                    >
                      <a :href="trailer.url" data-fancybox class="btn-play"></a>
                    </div>

                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <!-- MOBIE RATING SECTION -->
          <section class="d-md-none w-100 pb-3">
            <hr class="mt-0 mb-3" />
            <!-- MOBILE FIRST ROW -->
            <div class="col-12">
              <div class="row mx-0">
                <div class="col px-0">
                  <div class="small">Favourite</div>
                  <div>
                    1424
                    <span class="font-weight-light">(Times)</span>
                  </div>
                  <img
                    src="@/assets/img/svg/icon-heart-filled.svg"
                    class="mr-2"
                    height="15px"
                    width="15px"
                    alt="Heart-icon"
                  />
                </div>

                <div class="col px-0">
                  <div class="small">Critic Rating</div>
                  <div>
                    2.4
                    <span class="font-weight-light">(15 Votes)</span>
                  </div>
                  <star-rating
                    :show-rating="false"
                    :rating="4.5"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>

                <div class="col px-0">
                  <div class="small">Rating IT</div>
                  <div class="font-weight-bold">
                    2.4
                    <span class="font-weight-light">(159 Votes)</span>
                  </div>

                  <star-rating
                    :show-rating="false"
                    :rating="4.5"
                    :increment="0.5"
                    :inline="true"
                    :read-only="true"
                    active-color="#e5007d"
                    :star-size="13"
                  ></star-rating>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- FIXED BOTTOM BUTTON -->
    <!-- <section class="fixed-filter d-md-none">
      <button v-b-modal.quickBook-modal class="btn-filter-quickbook">Quick Book</button>
      <button v-on:click="filterModal = !filterModal" class="btn-filter">Filter</button>
    </section>-->

    <!-- MOVIE TRAILER MODAL -->
    <!-- FIXED BOTTOM BUTTON -->
    <section class="fixed-filter d-lg-none" v-if="false">
      <button
        style="width: 100%"
        v-on:click="filterModal = !filterModal"
        class="btn-filter"
      >
        Filter
      </button>
    </section>

    <!-- FILTER MODAL START-->
    <section v-if="filterModal" class="filter-modal">
      <div class="filter-modalContent">
        <nav>
          <img
            src="@/assets/img/svg/arrow-left.svg"
            height="20px"
            width="20px"
            alt="Back"
            v-on:click="filterModal = !filterModal"
          />
          <h6>Filter</h6>
          <a href v-on:click.native="onClearAllFilters()" class="btn-reset"
            >RESET</a
          >
        </nav>

        <div
          class="accordian-container"
          v-for="(filter, filterKey) in filters"
          :key="filterKey"
        >
          <button
            class="btn-accordian no-focus"
            :class="
              selectedFilter &&
              selectedFilter[filter.filter_key] &&
              selectedFilter[filter.filter_key].length > 0
                ? 'active'
                : ''
            "
            @click="onToggle(filter.collapseId)"
          >
            <img :src="filter.icon" height="15px" width="15px" />
            <span v-if="filter.filter_key == 'show_date'">{{
              selectedDate
            }}</span>
            <span v-else>{{ filter.filter_name }}</span>
          </button>
          <b-collapse
            class="accordian-container"
            accordion="my-accordion"
            role="tabpanel"
            :id="filter.collapseId"
          >
            <div
              class="btn-accordian-child d-flex align-items-center"
              v-for="(filterList, filterListKey) in filter.all_filter"
              :key="filterListKey"
            >
              <div v-if="filterList.inputtype == 'radio'">
                <span
                  :class="
                    filterList.value == selectedFilter['show_date'][0]
                      ? 'active'
                      : ''
                  "
                  v-on:click="
                    onClickFilter(
                      filter.filter_key,
                      filterList.value,
                      filterListKey,
                      filterList.title
                    )
                  "
                  >{{ filterList.title }}</span
                >
              </div>
              <div v-else class="d-flex align-items-center">
                <input
                  v-on:click="
                    onClickFilter(
                      filter.filter_key,
                      filterList.value,
                      filterListKey,
                      filterList.title
                    )
                  "
                  :id="filter.filter_key + filterListKey"
                  name="showdate"
                  type="checkbox"
                  :value="filterList.value"
                  :checked="
                    (selectedFilter[filter.filter_key] &&
                      filterList.value ==
                        selectedFilter[filter.filter_key][0]) ||
                    (selectedFilter['movie_language'] &&
                      filterList.value === selectedFilter['movie_language'][0])
                      ? true
                      : false
                  "
                />
                <label
                  class="mb-0"
                  :for="filter.filter_key + filterListKey"
                  :checked="
                    selectedFilter[filter.filter_key] &&
                    filterList.value ==
                      selectedFilter[filter.filter_key][filterKey]
                      ? true
                      : false
                  "
                  >{{ filterList.title }}</label
                >
              </div>
            </div>

            <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
            </ul>-->
          </b-collapse>
        </div>

        <div class="btn-container">
          <button
            v-on:click="filterModal = !filterModal"
            class="btn-applyFilter no-focus"
          >
            APPLY FILTER
          </button>
        </div>
      </div>
    </section>
    <!-- FILTER MODAL END -->
    <!-- FILTER MODAL START-->

    <!-- FILTER MODAL ENDS -->
    <div class="section-space"></div>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref
      id="coronaPopup"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-title"></div>
      <div class="mx-2">
        <div class="list-group text-white px-4">
          <h3 class="text-center">We Shall Be Back Soon!</h3>
          <p>
            In the wake of the news about COVID19, we are practicing social
            distancing. The ticket bookings on our platform will be discontinued
            temporarily until further notice from our cinema partners! Until
            then stay safe!
          </p>
        </div>
      </div>
      <div class="text-center">
        <router-link class="btn-light btn active mb-3 center" to="/"
          >Home</router-link
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "@/main";

import Slick from "vue-slick";
import UpCommingMovies from "@/components/partials/UpComingMovies.vue";
// import StarRating from "vue-star-rating";
// Vue.component("star-rating", StarRating);
import $ from "jquery";
import {
  LanguageService,
  CountryService,
  TokenService,
  ReferralService
} from "@/services/storage.service";
import { makeRequest } from "@/helper/internet.js";
import { validationMixin } from "vuelidate";
import Advertise from "@/components/partials/advertise.vue";
import { PROJECT } from "@/helper/constant.js";
import moment from "moment";
import { mapGetters } from "vuex";
import { URL_BASE, EVENT_URL } from "@/helper/constant";
// var async = require("async");

export default {
  props: {
    // Filter: {
    //   type: Object,
    //   default: {}
    // },

    cat_id: {
      type: String,
      default: ""
    },
    userReview: {
      type: Boolean,
      default: false
    }
  },
  name: "movieDetails",
  components: {
    Slick,
    UpCommingMovies,
    Advertise
  },

  data() {
    return {
      moment,
      ratingContent: null,
      selected_timingList: null,
      selected_allShowTimes: null,
      AvailableSeats: 0,
      CinemaAPIPath: "/GetCinemaSchedule",
      jsonld: "",
      project: PROJECT,
      shareURL: "",
      pageTitle: "Movie Details",
      ratingDetails: {
        currentUserRating: 0
      },
      filterModal: false,
      msg: "Welcome to Your HOMEPAGE",
      slickOptions: {
        slidesToShow: 3
      },
      shows: [1],
      tempShows: [],
      isShowsLoaded: false,
      allShows: [],
      youtubeURL: "i4K3os977h4",
      movieDetails: {},
      allDates: [],
      language: [],
      format: [],
      allcinemas: [],
      selectedDate: "Show Date",
      selectedCinema: "All Cinemas",
      selectedFormat: "All Formats",
      selectedLanguage: "All Language",
      movieID: "",
      movie_language: "",
      userId: "",
      youtubes: [],
      trailer: {
        url: "",
        thumbnail: ""
      },
      favChecked: false,
      filters: [],
      isSuccess: false,
      dateFilter: null,
      selectedFilter: {},
      rating: {
        userRatings: [],
        criticRatings: [],
        userRating: 0,
        currentUserRatingDetails: {
          title: "",
          currentUserRating: 0,
          content: ""
        },
        _currentUserRatingDetails: {
          title: "",
          currentUserRating: 0,
          content: ""
        },
        criticRating: 0,
        AvgRating: 0,
        criticRatingDetails: [],
        currentUserRating: {}
      },
      allShowingEvents: [],
      event_img_base_url: "",
      reviewSuccessMessage: "",
      selectedOrgId: "0",
      reviewdId: "",
      reportReviewMessage: "",
      reviewErrorMessage: "",
      ratingMessage: "",
      userRating: "",
      isError: "",
      cinemaID: "",
      loggedIn: false,
      tabIndex: 0,
      SeatTypes: [],
      SeatTypesValue: "",
      Currency: "",
      show: false,
      ShowLang: [],
      count: 0,
      categoryId: "",
      filtersChips: [],
      filterData: [],
      timingList: null,
      allShowTimes: [],
      countryID: "",
      languageID: ""
    };
  },
  computed: {
    ...mapGetters(["isRTL"])
  },
  metaInfo() {
    return {
      title:
        "Book Movie Tickets For " +
        this.pageTitle +
        " | " +
        this.pageTitle +
        " Movie Tickets"
    };
  },
  mixins: [validationMixin],

  beforeMount() {
    this.movieID = this.$route.params.movieID;
    this.cinemaID = this.$route.params.cinemaID;
    this.countryID = this.$route.params.CountryID;
    this.languageID = this.$route.params.LanguageID;

    this.fetchMovieDetails();
    this.fetchUserReview();
    this.fetchCtricReview();
    this.getAllFilters();
    this.getAllData();
    this.$cookies.set("retry_type", "movie", "1d");
    this.$cookies.set("retry_id", this.movieID, "1d");
    // this.fetchUserFav();
  },
  // destroyed() {
  //   if (this.$attrs.props && this.$attrs.props.selectedFilter) {
  //     this.$attrs.props.selectedFilter = {};
  //   }
  // },
  beforeDestroy() {
    this.secureStore.remove("SF");
  },
  created() {
    window.addEventListener("beforeunload", this.handler);
  },
  mounted() {
    if (process.env.NODE_ENV !== "development") {
      //this.$refs.coronaPopup.show();
    }
    // if (this.CinemaAPIPath) {
    //   //this.CinemaAPIPath = "/GetCinemaSchTK";
    //   this.CinemaAPIPath = "/GetCinemaSchedule";
    // }
    let country = CountryService.getCountry();
    if (country) {
      //do nothing
    } else {
      this.getCountryList();
    }
    this.shareURL = window.location.href;
    // this.$refs.tncModal.show();
    this.dateFilter = this.secureStore.get("SF");
    console.log("this.dateFilter :", this.dateFilter);
    // console.log("this.selectedFilter in mounted:", this.selectedFilter);
    // this.$root.$on("bv::tooltip::show", bvEvent => {
    //   console.log("bvEvent:", bvEvent);
    // });
    if (TokenService.getToken()) {
      this.loggedIn = true;
    }
    // branch.init("key_live_lgSDutp4w6xV8GnFUq8FYgebxskAtqf9", function(
    //   err,
    //   data
    // ) {
    //   console.log(err, data);
    // });
    console.log("this.$attrs :", this.$attrs);
    if (this.$attrs.props && this.$attrs.props.cat_id) {
      this.categoryId = this.$attrs.props.cat_id;
    }
    var linkData = {
      data: {
        $desktop_url: window.location.origin + this.$route.fullPath
      }
    };
  },
  watch: {
    $route(to, from) {
      this.movieID = this.$route.params.movieID;
      this.cinemaID = this.$route.params.cinemaID;

      this.fetchMovieDetails();
      this.fetchUserReview();
      this.fetchCtricReview();
      this.getAllFilters();
    }
  },
  methods: {
    getSeatType(show) {
      // this.onHoverShowTime(show);
      console.log(show);
    },
    checkLateNightPopup(data, timingListNew, timingList) {
      if (data) {
        // const t = this.$refs.LateNightPopup.show();
        EventBus.$on("timingList", user => {
          this.onAccept(timingListNew, timingList);
        });
        this.$refs.LateNightPopup.show();
      } else {
        this.onAccept(timingListNew, timingList);
      }
    },
    closeLateNightPopup() {
      EventBus.$emit("timingList");
    },
    setShows(orgId) {
      this.showLoading();
      this.shows = this.tempShows;

      this.selectedOrgId = orgId;

      if (orgId == "0") {
        this.getAllFilters();

        return false;
      }
      let selectedOrgCinemasShows = this.shows.filter(y => {
        return y.OrganizationID == orgId;
      });

      if (selectedOrgCinemasShows.length > 0) {
        this.shows = selectedOrgCinemasShows;
      } else {
        this.shows = [];
      }

      this.getAllFilters();
    },
    handler: function() {
      this.secureStore.remove("SF");
    },
    getCountryList: function() {
      makeRequest("/GetCountryList", "POST", null, {})
        .then(result => {
          const { error, res } = response;
          if (res.data.Status) {
            res.data.List.map(country => {
              if (this.countryID == country.CountryID) {
                CountryService.saveCountry(country);
              }
            });
          }
        })
        .catch(err => {});
    },
    onCancel: function() {
      this.$refs.tncModal.hide();
    },
    onAccept: function(timingList, _allShowTimes) {
      this.selected_timingList = timingList;
      this.selected_allShowTimes = _allShowTimes;
      console.log("onAccept", { timingList, _allShowTimes });
      this.$forceUpdate();

      if (this.ratingContent !== null) {
        // this.$refs.tncModal && this.$refs.tncModal.show();
        this.show = false;
        this.timingList = this.selected_timingList;
        this.allShowTimes = this.selected_allShowTimes.map(x => {
          x["ShowTime"] = x.time;
          x["SchID"] = x.id;
          x["Format"] = x.format;
          return x;
        });
        this.$router.push({
          name: "checkout",
          params: {
            movieID: this.movieID,
            scheduleID: this.selected_timingList.id,
            seatLayout: this.selected_timingList.seatlayout,
            props: { allShowTimes: this.allShowTimes }
          }
        });
      } else {
        if (timingList.hover) {
          this.show = false;
          this.timingList = timingList;
          this.allShowTimes = _allShowTimes.map(x => {
            x["ShowTime"] = x.time;
            x["SchID"] = x.id;
            x["Format"] = x.format;
            return x;
          });

          console.log(this.movieID, timingList.id, timingList.seatlayout, "jj");
          this.$router.push({
            name: "checkout",
            params: {
              movieID: this.movieID,
              scheduleID: timingList.id,
              seatLayout: timingList.seatlayout,
              props: { allShowTimes: this.allShowTimes }
            }
          });
          // this.$refs.tncModal.show();
        }
      }
    },
    onClickCinemaTime: function() {
      console.log("onClickCinemaTime");
      // this.$router.push({
      //   name: "checkout",
      //   params: {
      //     movieID: movieID,
      //     scheduleID: timingList.id,
      //     seatLayout: timingList.seatlayout,
      //     props: { allShowTimes: this.allShowTimes }
      //   }
      // });

      this.show = false;
      this.timingList = this.selected_timingList;
      this.allShowTimes = this.selected_allShowTimes.map(x => {
        x["ShowTime"] = x.time;
        x["SchID"] = x.id;
        x["Format"] = x.format;
        return x;
      });
      this.$router.push({
        name: "checkout",
        params: {
          movieID: this.movieID,
          scheduleID: this.selected_timingList.id,
          seatLayout: this.selected_timingList.seatlayout,
          props: { allShowTimes: this.allShowTimes }
        }
      });
    },
    setLanguage: function(Lang, index) {
      this.youtubes = [];
      this.movie_language = Lang.LanguageID;

      let selectedMovie = this.movieDetails.links.filter(y => {
        return y.LanguageID == Lang.LanguageID;
      });

      if (selectedMovie.length > 0) {
        this.movieDetails.lang = selectedMovie[0].Title;
        this.movieDetails.movie_card_img = selectedMovie[0].movie_card_img;

        this.trailer.url = selectedMovie[0].Youtube;
        this.youtubes.push({
          thumbnail: `https://img.youtube.com/vi/${selectedMovie[0].Youtube}/0.jpg`,
          url: `https://www.youtube.com/watch?v=${selectedMovie[0].Youtube}`
        });

        //this.selected_movie_Title_lang=selectedMovie[0].Title
      }

      console.log(this.movieDetails, "lang");
      // this.selectedFilter["movie_language"] = [Lang.LanguageID];
      //  this.onClickFilter("movie_language", Lang.LanguageID, index, Lang.Title);
      // this.selectedFilter["show_date"] = [
      //         this.filters[3].all_filter[0].value
      //       ];
      this.getShowTimings();
      this.$refs.LangModal.hide();
    },
    onHoverShowTime: function(showtime) {
      if (showtime.hover) {
        this.SeatTypes = [];
        let payload = {
          SchID: showtime.id
        };
        console.log(payload);
        makeRequest("/GetSeatType", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            //res.data.Status = false;
            if (res.data.Status) {
              this.showLoading();

              this.SeatTypes = res.data.SeatTypes;
              this.Currency = res.data.Currency;
              this.show = true;
              this.AvailableSeats = res.data.AvailableSeats;
              console.log(this.AvailableSeats);
              this.hideLoading();
            } else {
              this.$toasted.show("Booking is not available");
              setTimeout(() => {
                this.$toasted.clear();
              }, 1000);
              //this.SeatTypes[0]["SeatType"] = "Booking is not available";
              //this.show = true;
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
        // console.log("showtime :", showtime);
      } else {
        this.SeatTypesValue = showtime.hover_message;
      }
    },
    onClickAbuseFlag: function(rating) {
      let token = TokenService.getToken();
      if (!token) {
        this.checkSignIn();
      } else {
        this.reviewdId = rating.ID;
        let payload = {
          RatingID: rating.ID
        };
        makeRequest("/FlagAbuse", "POST", token, payload)
          .then(response => {
            const { error, res } = response;
            this.reportReviewMessage = res.data.Message;
          })
          .catch(error => {
            this.reviewErrorMessage = "Something went wrong!";
            console.log("Error", error);
          });
        setTimeout(() => {
          this.reportReviewMessage = "";
        }, 3000);
      }
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    onToggle: function(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },
    onClickFilter: function(filter_key, value, index, title) {
      // this.showLoading();
      this.movie_language = "";

      let obj = {};
      obj[filter_key] = [];

      this.selectedFilter = {
        ...obj,
        ...this.selectedFilter
      };
      let _index = this.selectedFilter[filter_key].indexOf(value);
      if (filter_key == "show_date") {
        this.selectedDate = title;
        this.selectedFilter[filter_key] = [value];
        this.onToggle("collapse-1");
      } else {
        //filterchips
        let __index = this.filtersChips.findIndex(x => x.title === title);

        if (__index > -1) {
          this.filtersChips.splice(__index, 1);
        } else {
          this.filtersChips.push({
            title: title,
            filter_key: filter_key,
            value: value
          });
        }
        //
        if (_index > -1) {
          this.selectedFilter[filter_key].splice(_index, 1);
        } else {
          this.selectedFilter[filter_key].push(value);
        }
      }
      this.getShowTimings();
    },
    onClearAllFilters: function() {
      this.filtersChips = [];
      this.selectedFilter = {};
      this.selectedFilter["show_date"] = [this.filters[0].all_filter[0].value];
      this.selectedDate = this.filters[0].all_filter[0].title;
      this.getShowTimings();
    },
    onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      let _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.getShowTimings();
    },
    filterShowData: function(data, filter) {
      if (filter == "date") {
        this.selectedDate = data;
        this.selectedDate.Date = data.ShowDate;
        this.getShowTimings();
        this.getCinemas(data.ID);
        this.filterShowData("All Cinemas", "cinema");
      }
      if (filter == "cinema") {
        this.selectedCinema = data;
        if (data == "All Cinemas") {
          this.shows = this.allShows;
        } else {
          this.shows = this.allShows.filter(x => {
            return x.name === data;
          });
        }
      }
      if (filter == "format") {
        this.selectedFormat = data;
        if (data == "All Formats") {
          this.shows = this.allShows;
        } else {
          this.filterAllData();
        }
      }
      if (filter == "languaeg") {
        this.selectedLanguage = data;
        this.filterAllData();
      }
    },
    filterAllData: function() {
      this.shows.map(cinema => {
        cinema.timings.filter(timing => {
          if (timing.format === this.selectedFormat) {
            return cinema;
          } else if (cinema.name === this.selectedCinema) {
            return cinema;
          } else if (timing.name == this.selectedLanguage) {
            return cinema;
          }
        });
      });
      // console.log("hererererere", this.filterAllData);
    },
    checkSignIn: function() {
      EventBus.$emit("openSignInModal");
    },

    getAllFilters: function() {
      this.filters = [];
      let self = this;
      let payload = {
        FilterType: "Movie",
        MovieID: this.movieID,
        OrganizationID: 3
      };
      if (this.cinemaID != "" && this.cinemaID > 0) {
        payload["CinemaID"] = this.cinemaID;
      }

      makeRequest("/GetAllFilter", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.hideLoading();
            if (res.data.Filters[0].all_filter.length > 0) {
              self.filters = [];

              Promise.all([_function1])
                .then(values => {
                  self.getShowTimings();
                })
                .catch(error => {
                  self.getShowTimings();
                });

              const _function1 = new Promise((resolve, reject) => {
                res.data.Filters.map((x, index) => {
                  self.filters.push({
                    ...x,
                    collapseId: "collapse-" + (index + 1)
                  });
                });

                self.selectedFilter = [];
                if (self.$attrs.props && self.$attrs.props.selectedFilter) {
                  self.selectedFilter = self.$attrs.props.selectedFilter;
                }

                let date_value = self.filters[0].all_filter[0].value;
                let date_title = self.filters[0].all_filter[0].title;
                self.filters[0].all_filter.map((x, index) => {
                  let a = moment.unix(x.value).format("YYYY-MM-DD");
                  let b =
                    self.dateFilter &&
                    self.dateFilter.show_date &&
                    self.dateFilter.show_date.length > 0
                      ? moment
                          .unix(self.dateFilter.show_date[0])
                          .format("YYYY-MM-DD")
                      : null;

                  if (b && moment(a).isSame(moment(b))) {
                    date_value = self.filters[0].all_filter[index].value;
                    date_title = self.filters[0].all_filter[index].title;
                    self.selectedFilter["show_date"] = date_value;
                    self.selectedDate = date_title;
                  } else {
                    self.selectedFilter["show_date"] = date_value;
                    self.selectedDate = date_title;
                  }
                });

                if (self.$attrs.props && self.$attrs.props.selectedFilter) {
                  self.selectedFilter = self.$attrs.props.selectedFilter;

                  Object.keys(self.selectedFilter).map(x => {
                    self.filters.map(z => {
                      z.all_filter.map(y => {
                        if (
                          x == z.filter_key &&
                          self.selectedFilter[x] == y.value
                        ) {
                          self.filtersChips.push({
                            title: y.title,
                            filter_key: y.filter_key,
                            value: y.value
                          });
                        } else {
                        }
                      });
                    });
                  });
                }
                resolve(self.selectedFilter);
              });
            }
          } else {
            this.hideLoading();
            console.log("Response Error ");
          }
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
    validateBeforeSubmit(scope) {
      this.$validator.validateAll().then(result => {
        if (scope == "addUserRating") {
          if (
            result &&
            this.rating.currentUserRatingDetails.title.length > 0 &&
            this.rating.currentUserRatingDetails.content.length > 0
          ) {
            //check if user is logged in from token
            let token = TokenService.getToken();
            if (scope == "addUserRating") {
              if (token == null || token == "") {
                this.rating.currentUserRatingDetails.currentUserRating = this.rating._currentUserRatingDetails.currentUserRating;
                this.checkSignIn();
                // open sign in modal
                // return;
              }
              let payload = {
                MovieID: this.movieID,
                Title: this.rating.currentUserRatingDetails.title,
                Rating: this.rating.currentUserRatingDetails.currentUserRating,
                Review: this.rating.currentUserRatingDetails.content
              };
              makeRequest("/AddRatings", "POST", token, payload)
                .then(response => {
                  const { error, res } = response;
                  if (res.data.Status) {
                    // if (x.MovieId == this.movieID) {
                    this.userRating = parseInt(
                      (this.ratingDetails.currentUserRating = true)
                    );
                    // }
                    this.isError = false;
                    this.isSuccess = true;
                    setTimeout(() => {
                      this.isSuccess = false;
                    }, 3000);
                    this.fetchUserReview();
                    this.reviewSuccessMessage =
                      "Thank you for your review, it is under moderation";
                  } else {
                    this.reviewErrorMessage = res.data.Message;
                  }
                })
                .catch(error => {
                  this.reviewErrorMessage = error;
                  console.log("Error", error);
                });
              // eslint-disable-next-line
              return;
            }
          } else {
            this.isError = true;
            return false;
          }
        }
      });
      // addOnlyUserRating
      this.$validator.validateAll().then(result => {
        if (scope == "addOnlyUserRating") {
          //check if user is logged in from token
          let token = TokenService.getToken();
          if (scope == "addOnlyUserRating") {
            if (token == null || token == "") {
              this.rating.currentUserRatingDetails.currentUserRating = this.rating._currentUserRatingDetails.currentUserRating;
              this.checkSignIn();
              // open sign in modal
              // return;
            }
            let payload = {
              MovieID: this.movieID,
              Title: this.rating.currentUserRatingDetails.title,
              Rating: this.rating.currentUserRatingDetails.currentUserRating,
              Review: this.rating.currentUserRatingDetails.content
            };
            makeRequest("/AddRatings", "POST", token, payload)
              .then(response => {
                const { error, res } = response;
                if (res.data.Status) {
                  // if (x.MovieId == this.movieID) {
                  this.userRating = parseInt(
                    (this.ratingDetails.currentUserRating = true)
                  );
                  // }
                  this.isError = false;
                  this.isSuccess = true;
                  setTimeout(() => {
                    this.isSuccess = false;
                  }, 3000);
                  this.fetchUserReview();
                  this.reviewSuccessMessage =
                    "Thank you for your review, it is under moderation";
                } else {
                  this.reviewErrorMessage = res.data.Message;
                }
              })
              .catch(error => {
                this.reviewErrorMessage = error;
                console.log("Error", error);
              });
            // eslint-disable-next-line
            return;
          }
        }
      });
    },
    ready(event) {
      this.player = event.target;
    },
    async getRatingContent(MovieID = "") {
      let payload = { MovieID };

      let { error, res } = await makeRequest(
        "/GetRatingContent",
        "POST",
        null,
        payload
      );
      if (!error && res.data && res.data.Status && res.data.Data) {
        this.ratingContent = res.data.Data;

        if (this.ratingContent) {
          // this.$refs.tncModal && this.$refs.tncModal.show()
        }
      } else {
        console.error({ error });
        this.$refs.tncModal && this.$refs.tncModal.hide();
      }
    },

    fetchMovieDetails() {
      //this.showLoading();
      this.showLoading();
      let token = null;
      let payload = {
        MovieID: this.movieID
      };
      // if (this.$persistStore.get("accessToken")) {
      //   token = this.$persistStore.get("accessToken");
      //   payload["access_token"] = token;
      // }
      makeRequest("/GetShowDetails", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              this.movieDetails = res.data.Show[0];
              console.log("Just Checked", this.movieDetails);
              this.shareURL = res.data.MovieShareURL;
              this.pageTitle = this.movieDetails.title;
              this.jsonld = res.data.meta;
              if (this.movieDetails.CategoryID == 3) {
                this.tabIndex = 0;
                this.getShowTimings();
              } else {
                this.hideLoading();
              }
              console.log(
                "this.movieDetails.CategoryID :",
                this.movieDetails.CategoryID
              );
              // this.jsonld.name = this.movieDetails.title;
              // this.jsonld.description = this.movieDetails.plot;
              // console.log(this.jsonld.actor.length);
              // $.each(this.movieDetails.cast, function(key, value){
              //   if(value.CastType == "Actor") {
              //     console.log(value.Name+" - "+this.jsonld.actor.length);
              //     //this.jsonld.actor.push({"@type":"Person", "name":value.Name});
              //   }
              // });
              // this.movieDetails.cast.map(value=>{
              //     console.log(value.CastType)
              //   if(value.CastType == "Actor") {
              //     this.jsonld.actor.push({"@type":"Person", "name":value.Name});
              //   }
              //   else if(value.CastType == "Director"){
              //     this.jsonld.director.push({"@type":"Person", "name":value.Name});
              //   }
              // });
              // this.selectedFormat = this.movieDetails.format;
              // this.movieDetails.cast.map(x => {
              //   this.movieCast.push(x.Name);
              //   console.log("this.movieCast :", this.movieCast);
              // });

              if (this.movieDetails.cat_id != 2) {
                // this.getShowDates();
              }
              if (
                this.movieDetails.videos &&
                this.movieDetails.videos.length > 0
              ) {
                if ((this.$route.params.attr = "search")) {
                  this.youtubes = [];
                }
                this.movieDetails.videos.map(url => {
                  this.youtubes.push({
                    thumbnail: `https://img.youtube.com/vi/${url}/0.jpg`,
                    url: `https://www.youtube.com/watch?v=${url}`
                  });
                });
              }
              this.trailer.thumbnail = `https://img.youtube.com/vi/${this.movieDetails.video}/0.jpg`;
              this.trailer.url = `https://www.youtube.com/watch?v=${this.movieDetails.video}`;
              this.format = this.movieDetails.format.split(",");
              this.format.push("All Formats");
              //this.hideLoading();
              let desc =
                this.movieDetails.title +
                " Movie (" +
                this.movieDetails.release +
                "), " +
                this.movieDetails.genre +
                " released in " +
                this.movieDetails.lang +
                ". Know about Film reviews, lead cast & crew, photos on Ticketak";

              document
                .querySelector("title")
                .setAttribute(
                  "content",
                  this.movieDetails.title +
                    " Movie (" +
                    this.movieDetails.release +
                    ") - Ticketak Cinemas"
                );
              // document
              //   .querySelector('meta[name="description"]')
              //   .setAttribute("content", desc);
              // document
              //   .querySelector('meta[name="title"]')
              //   .setAttribute(
              //     "content",
              //     this.movieDetails.title +
              //       " Movie (" +
              //       this.movieDetails.release +
              //       ") - Ticketak Cinemas"
              //   );
              // document
              //   .querySelector('meta[property="og:description"]')
              //   .setAttribute("content", desc);
              // document
              //   .querySelector('meta[property="og:image"]')
              //   .setAttribute("content", this.movieDetails.AppImageMovies);

              // this.language = this.movieDetails.lang.split(",");
              // this.movieDetails.IMDBRating = Math.round(
              //   parseFloat(this.movieDetails.IMDBRating.split("/")[0])
              // );
              // this.$refs.slick1.destroy();
              // this.$nextTick(() => {
              //   this.$refs.slick1.create();
              //   this.$refs.slick1.goTo(1, true);
              // });
              // this.movieDetails.genre.map(x => {
              //   this.movieCast.push(x.Name);
              //   console.log("this.movieCast :", this.movieCast);
              // });
              // this.movieDetails.IMDBRating = Math.round(
              //   parseFloat(this.movieDetails.IMDBRating)
              // );
              // if (this.movieDetails.Trailers && this.movieDetails.Trailers[0]) {
              //   this.youtube =
              //     "https://www.youtube.com/embed/" +
              //     this.movieDetails.Trailers[0].URI;
              // }
              // this.userRatingDetails.user = this.movieDetails.YourRating;
              // console.log("y", this.youtube);
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error", error);
        })
        .then(() => {
          return this.getRatingContent(this.movieID);
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

    onclickShare: function() {
      FB.ui(
        {
          method: "share",
          href: this.shareURL
        },
        function(response) {
          console.log(response);
        }
      );
    },
    onClickTwitterShare: function() {
      var txt = this.shareURL;
      var url2 =
        "https://twitter.com/intent/tweet?text=" + encodeURIComponent(txt);

      newwindow = window.open(url2, "ABCD", "height=450,width=650");
      if (window.focus) {
        newwindow.focus();
      }
    },
    getStringDate: function(addDay) {
      var date = new Date();
      if (addDay) {
        date.setDate(date.getDate() + 1);
      }
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      // var month = monthIndex + 1;
      day = day < 10 ? "0" + day : day;
      // return year + "-" + month + "-" + day;
      return day + " " + monthNames[monthIndex] + " " + year;
    },
    getShowDates: function() {
      let payload = {
        MovieID: this.$route.params.movieID
      };
      makeRequest("/GetShowDates/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            this.allDates = res.data.Dates;
            for (let i in this.allDates) {
              if (this.allDates[i].ShowDate == this.getStringDate(false)) {
                this.allDates[i].ShowDate = "Today";
              }
              if (this.allDates[i].ShowDate == this.getStringDate(true)) {
                this.allDates[i].ShowDate = "Tomorrow";
              }
            }

            // this.allDates[0].Date = "Today";
            // if (this.allDates.length > 1) {
            //   this.allDates[1].Date = "Tomorrow";
            // }
            this.selectedDate.Date = this.allDates[0].ShowDate;
            this.allDates = this.allDates.filter((x, index) => {
              return index < 7;
            });
            this.selectedDate.ID = this.allDates[0].ID;
            this.getShowTimings();
            this.allDates.map(x => {
              this.getCinemas(this.selectedDate.ID);
            });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getCinemas: function(dateId) {
      let payload = {
        MovieID: this.$route.params.movieID,
        DateID: dateId,
        OrganizationID: 3
      };
      makeRequest(this.CinemaAPIPath, "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            this.allcinemas = res.data.Data;
            this.allcinemas.push({ name: "All Cinemas" });
            // this.selectedCinema = this.allcinemas[0].name;
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getShowTimings: function() {
      this.isShowsLoaded = false;
      this.allShows = [];
      this.shows = [];
      this.tempShows = [];
      let payload = {
        MovieID: this.$route.params.movieID,
        DateID: this.selectedDate.ID,
        movie_language: this.movie_language,
        OrganizationID: 3

      };
      Object.keys(this.selectedFilter).map(x => {
        if (this.selectedFilter[x].length > 0) {
          payload[x] = this.selectedFilter[x].toString();
        }
      });
      // if (this.cinemaID !== "0") {
      //   payload["cinema_name"] = this.cinemaID;
      // }

      
      makeRequest(this.CinemaAPIPath, "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            this.shows = res.data.Data;
            this.tempShows = res.data.Data;
            this.ShowLang = res.data.ShowLangPlaying;
            if (this.ShowLang.length > 1 && this.movie_language == "") {
              this.$refs.LangModal.show();
            }
            if (this.tempShows.length > 0) {
              for (let q = 0; q < this.tempShows.length; q++) {
                let addedScreenIds = [];
                this.tempShows[q]["screenWiseTimeings"] = [];
                for (let p = 0; p < this.tempShows[q].timings.length; p++) {
                  if (
                    !addedScreenIds.includes(
                      this.tempShows[q].timings[p].screenid
                    )
                  ) {
                    let screenName = this.tempShows[q].timings.filter(z => {
                      return (
                        z.screenid == this.tempShows[q].timings[p].screenid
                      );
                    });
                    if (screenName.length > 0) {
                      // this.shows[q].screenWiseTimeings.push(screenName);
                      this.tempShows[q].screenWiseTimeings.push(screenName);
                      addedScreenIds.push(
                        this.tempShows[q].timings[p].screenid
                      );
                    }
                  }
                  //  console.log(addedScreenIds, "hhhh");
                }
              }
              this.shows = this.tempShows;
            }
            this.isShowsLoaded = true;
            if (this.selectedOrgId == "0") {
              this.hideLoading();
              return false;
            }
            let selectedOrgCinemasShows = this.shows.filter(y => {
              return y.OrganizationID == this.selectedOrgId;
            });

            if (selectedOrgCinemasShows.length > 0) {
              this.shows = selectedOrgCinemasShows;
            } else {
              this.shows = [];
            }

            console.log(this.tempShows, "hhhh");

            this.hideLoading();
            this.isShowsLoaded = true;
          } else {
            this.isShowsLoaded = true;
            console.log("Response Error ");
            this.hideLoading();
          }
        })
        .catch(error => {
          this.isShowsLoaded = true;
          console.log("Error", error);
          this.hideLoading();
        });
    },
    stopYoutube: function() {
      this.player.stopVideo();
    },
    fetchUserFav: function() {
      let token = TokenService.getToken();
      if (token) {
        let payload = {
          access_token: token
        };
        makeRequest("/api/GetFavourite/", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            if (!error) {
              let Favs = res.data.List;
              Favs.map(x => {
                if (x.MovieId == this.movieID) {
                  this.favChecked = true;
                }
              });
            } else {
              this.checkSignIn();
              console.log("User not loggedIn");
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
      }
    },
    fetchUserReview: function() {
      let token = TokenService.getToken();
      let payload = {
        MovieID: this.movieID,
        UserReview: false
      };
      makeRequest("/GetRatings", "POST", token, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            this.rating.userRatings = res.data.RatingList;
            res.data.RatingList.map(rating => {
              if (rating.Flag == 1) {
                this.rating._currentUserRatingDetails.currentUserRating = parseFloat(
                  rating.Rating
                );
                this.rating._currentUserRatingDetails.title = rating.Title;
                this.rating._currentUserRatingDetails.content = rating.Review;
                this.rating.currentUserRatingDetails.currentUserRating = parseFloat(
                  rating.Rating
                );
                this.rating.currentUserRatingDetails.title = rating.Title;
                this.rating.currentUserRatingDetails.content = rating.Review;
              }
            });
            function array_move(arr, old_index, new_index) {
              if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                  arr.push(undefined);
                }
              }
              arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
              return arr; // for testing
            }
            // let index = this.rating.userRatings.findIndex(x => x.Flag == 1);
            // array_move(this.rating.userRatings, index, 0);
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    fetchCtricReview: function() {
      let payload = {
        MovieID: this.$route.params.movieID
      };
      makeRequest("/GetCriticRatings", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            this.rating.criticRatings = res.data.Reviews;
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    addtoFav() {
      let token = TokenService.getToken();
      if (token) {
        let payload = {
          MovieID: this.movieID,
          Like: 1,
          FireBaseID: "",
          favourite: !this.movieDetails.favourite
        };
        makeRequest("/AddFavourite", "POST", token, payload)
          .then(response => {
            const { error, res } = response;
            if (res.data) {
              this.ratingMessage = res.data.Message;
              // if (x.MovieId == this.movieID) {
              this.favChecked = true;
              if (this.movieDetails.favourite == true) {
                parseInt(this.movieDetails.interestedcount--);
              } else {
                parseInt(this.movieDetails.interestedcount++);
              }
              this.movieDetails.favourite = !this.movieDetails.favourite;
              // }
              // this.favChecked = true;
            } else {
              this.ratingMessage = res.data.Message;
            }

            setTimeout(() => {
              this.ratingMessage = "";
            }, 3000);
          })
          .catch(error => {
            this.ratingMessage = "Something went wrong";
          });
      } else {
        this.checkSignIn();
      }
    },

    submitReview() {},

    //  Events
    getAllData: function() {
      //this.showLoading();

      makeRequest("/v1/event/getAllEvent", "POST", null, null, EVENT_URL)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            // this.hideLoading();

            console.log("Ruchi Data", res.data.now_showing);
            this.event_img_base_url = res.data.base_url;
            // this.eventBanners = res.data.banners;
            // this.upCommingEvents = res.data.comming_soon.data;
            // this.nowShowingEvents = res.data.now_showing.data;
            this.allShowingEvents = [...res.data.now_showing];
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    goToEventDetails(data) {
      console.log("Event Details", data);
      this.$router.push({
        name: "eventDetails",
        params: {
          eventID: data.event_id
        }
      });
    }
  }
};
</script>
<style>
.filter-list li {
  padding: 15px 40px;
}

.filter-list li input::after {
  content: "" !important;
  height: 0;
  width: 0;
}
</style>

<style scoped>
.my-tooltip-class {
  display: none;
}

.filter-list li {
  padding: 15px 40px;
}

.filter-list li input::after {
  content: "" !important;
  height: 0;
  width: 0;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/pages/movieDetails.vue